{
  "account.account": "Perfil e segurança",
  "account.accountDeleted": "A sua conta foi eliminada com sucesso.",
  "account.accountDescription": "Nome, palavra-passe, eliminar conta",
  "account.accountSection": "Conta",
  "account.changeEmail": "Alterar e-mail",
  "account.changePassword": "Mudar palavra-passe",
  "account.currentPassword": "Palavra-passe atual",
  "account.dangerZone": "Zona de risco",
  "account.deleteAccount": "Eliminar conta",
  "account.deleteAccountConfirmation": "Tem a certeza de que deseja eliminar a sua conta? Esta ação é irreversível.",
  "account.deleteAccountDescription": "Esta ação elimina a sua conta e todas as suas informações. Não há retorno.",
  "account.emailChange": "Alterar endereço de e-mail",
  "account.emailChangeConfirmation": "Confirmação de alteração de e-mail",
  "account.emailChangeFailure": "O link de alteração de e-mail é inválido ou expirou.",
  "account.emailChangeIntro": "Introduza o seu novo endereço de e-mail e a sua palavra-passe atual. Enviaremos uma ligação para o novo endereço: o seu e-mail só muda depois de a abrir.",
  "account.emailChangeNeedsPassword": "Para alterar o seu endereço de e-mail, defina primeiro uma palavra-passe. Vamos enviar-lhe uma ligação por e-mail para o fazer. A sessão mantém-se iniciada.",
  "account.emailChangeSetPasswordFirst": "Para alterar o seu endereço de e-mail, defina primeiro uma palavra-passe.",
  "account.emailChangeSuccess": "Seu e-mail foi alterado com sucesso para {newEmail}.",
  "account.emailChangeSuccessNoAddress": "O seu endereço de e-mail foi alterado com sucesso.",
  "account.emailChangeVerificationSent": "Um e-mail de verificação foi enviado para o seu novo endereço de e-mail. Por favor, verifique sua caixa de entrada e clique no link para confirmar a alteração.",
  "account.manageAccount": "Gerir conta",
  "account.newEmailAddress": "Novo endereço de e-mail",
  "account.newPassword": "Nova palavra-passe",
  "account.newPasswordAgain": "Nova palavra-passe outra vez",
  "account.noPasswordExplanation": "A sua conta ainda não tem palavra-passe SmartMixin, porque inicia sessão com Google, Apple ou Facebook. Vamos enviar-lhe por e-mail uma ligação para definir uma. A sessão mantém-se iniciada.",
  "account.oldPassword": "Palavra-passe antiga",
  "account.passwordChange": "Alterar palavra-passe",
  "account.passwordChangeDescription": "Mantenha a sua conta segura",
  "account.passwordUpdated": "Palavra-passe atualizada com sucesso.",
  "account.profile": "Perfil",
  "account.profileUpdated": "Perfil atualizado com sucesso.",
  "account.reauthAccountMismatchApple": "Essa Conta Apple não é a que está associada ao SmartMixin. Tente novamente com a Conta Apple com que inicia sessão.",
  "account.reauthAccountMismatchGoogle": "Essa conta Google não é a que está associada ao SmartMixin. Tente novamente e escolha a conta Google com que inicia sessão.",
  "account.reauthAccountMismatchGoogleNamed": "Essa conta Google não é a que está associada ao SmartMixin. Tente novamente e escolha {email}.",
  "account.reauthConfirmBody": "Para alterar o seu endereço de e-mail, confirme com a conta com que inicia sessão.",
  "account.reauthConfirmed": "Confirmado com {provider}",
  "account.reauthConfirmTitle": "Confirme que é você",
  "account.reauthExpired": "A sua confirmação expirou. Confirme novamente para continuar.",
  "account.reauthFailed": "Não foi possível confirmar que é você. Tente novamente.",
  "account.reauthPopupBlocked": "O seu navegador bloqueou a janela da Apple. Prima novamente o botão.",
  "account.reauthProviderUnavailable": "O {provider} não está a responder neste momento. Tente novamente dentro de alguns minutos.",
  "account.reauthSetPasswordInstead": "Definir antes uma palavra-passe",
  "account.reauthThrottled": "Tentou confirmar várias vezes num curto espaço de tempo. Tente mais tarde.",
  "account.sendSetPasswordLink": "Enviar-me uma ligação",
  "account.sendSetPasswordLinkLong": "Enviar-me uma ligação para definir a palavra-passe",
  "account.setPassword": "Definir uma palavra-passe",
  "account.setPasswordDescription": "A sua conta ainda não tem palavra-passe",
  "account.setPasswordFirst": "Definir primeiro uma palavra-passe",
  "account.setPasswordLinkError": "Não foi possível enviar a ligação. Verifique a sua ligação à internet e tente novamente.",
  "account.setPasswordLinkRateLimited": "Pediu várias ligações num curto espaço de tempo. Procure a mais recente na caixa de entrada e na pasta de spam, ou tente mais tarde.",
  "account.setPasswordLinkResend": "Enviar novamente",
  "account.setPasswordLinkRetry": "Tentar novamente",
  "account.setPasswordLinkSent": "Enviámos uma ligação para {email}. Abra-a para escolher a sua palavra-passe e depois volte aqui.",
  "account.signedInAs": "Sessão iniciada como",
  "account.updateYourProfile": "Atualizar o seu perfil",
  "account.updateYourProfileDescription": "Nome e preferências de exibição",
  "addons.accountOnHold": "A conexão da sua conta expirou. Reconecte-se para retomar as atualizações de dados.",
  "addons.accountOnHoldTitle": "Conta suspensa",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Crie e recupere sua chave de API neste link",
  "addons.ambientWeatherDescription": "Estações meteorológicas Ambient Weather (WS-5000, WS-2000, WS-2902C, …)",
  "addons.apiKey": "Chave API",
  "addons.applicationKey": "Chave da aplicação",
  "addons.availableServices": "Disponíveis",
  "addons.cannotDisconnectLastAccount": "Não é possível desconectar o seu único método de login. Por favor, adicione primeiro outro método de login.",
  "addons.connect": "Conectar",
  "addons.connected": "Conectado",
  "addons.connectedAccounts": "Contas conectadas",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "A carregar as suas contas conectadas…",
  "addons.connectedServices": "Conectados",
  "addons.connectedSince": "Conectado desde {date}",
  "addons.connectionSection": "Ligação",
  "addons.connectionSuccess": "Conta {provider} conectada com sucesso",
  "addons.davisApiSecret": "Segredo da API",
  "addons.davisApiV2Key": "Chave API V2",
  "addons.davisDescription": "Estações meteorológicas Davis (Vantage Vue, Vantage Pro 2, …)",
  "addons.davisRetrieveApiKey": "Recuperar as suas chaves API V2 a partir deste link",
  "addons.disconnect": "Desconectar",
  "addons.disconnectConfirmation": "Tem a certeza de que deseja desconectar a sua conta {provider}?",
  "addons.disconnectEnergyConfirmation": "O SmartMixin deixará de sincronizar o Netatmo Energy e removerá as suas casas do SmartMixin. A sua conta Netatmo e os seus dispositivos não são afetados.",
  "addons.disconnectEnergyDescription": "Para a sincronização e remove as suas casas do SmartMixin.",
  "addons.disconnectionSuccess": "Conta {provider} desconectada com sucesso",
  "addons.disconnectProviderDescription": "Para a sincronização e elimina as estações deste serviço e o respetivo histórico.",
  "addons.disconnectServiceConfirmation": "O SmartMixin deixará de sincronizar {provider} e eliminará as estações deste serviço e todo o respetivo histórico. A sua conta {provider} em si não é afetada.",
  "addons.disconnectServiceTitle": "Desconectar {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Crie e recupere sua chave de API e chave de aplicação neste link",
  "addons.ecowittDescription": "A Ecowitt fornece estações meteorológicas profissionais, termômetros internos/externos sem fio, pluviômetros de alta precisão, sensores de qualidade do ar e muito mais.",
  "addons.helpLink": "Como conectar {provider}",
  "addons.integrationsSection": "Integrações",
  "addons.myAcuriteAccountOnHold": "A sua conta foi colocada em espera. Por favor, introduza a sua palavra-passe para reconectar a sua conta",
  "addons.myAcuriteDescription": "AcuRite é a marca de estações meteorológicas nº 1 na América do Norte. Como líder em tecnologia de tempo, temperatura e clima, a AcuRite fornece informações detalhadas sobre o seu ambiente interno e externo para que possa planear o seu dia com confiança.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilize o seu Termóstato Netatmo para mudar a temperatura da sua casa, da sua cama ou de outra parte do mundo",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "A sua estação meteorológica pessoal em casa",
  "addons.notConnected": "Não conectado",
  "addons.or": "ou",
  "addons.providerAccountDisconnected": "A conexão com o seu serviço meteorológico expirou. Reconecte-se para retomar as atualizações de dados.",
  "addons.reconnect": "Reconectar",
  "addons.socialConnectionsIntro": "Vincule as suas contas sociais para um login rápido. Pode conectar ou desconectar contas a qualquer momento.",
  "addons.weatherflowAccessToken": "Token de acesso",
  "addons.weatherflowCreateToken": "Criar e recuperar o seu token a partir deste link",
  "addons.weatherflowTempestDescription": "Estação meteorológica Tempest com anemómetro e pluviómetro incorporados",
  "addons.weatherServices": "Serviços meteorológicos",
  "addons.weatherServicesConnected": "{count, plural, =0 {Nenhum serviço conectado} one {# serviço conectado} other {# serviços conectados}}",
  "addons.weatherServicesDescription": "Conecte Netatmo, Davis, Weatherflow e mais",
  "addons.wundergroundApiKey": "Chave API",
  "addons.wundergroundDescription": "Weather Underground é uma comunidade global de pessoas que liga dados de sensores ambientais como estações meteorológicas e monitores de qualidade do ar para que possamos fornecer os dados ricos e hiperlocais de que necessita para alimentar as suas paixões",
  "addons.wundergroundRemoveStationDescription": "A estação sai da sua conta SmartMixin. A menos que outra conta SmartMixin também a tenha adicionado, a estação e o histórico que o SmartMixin registou para ela são apagados. Nada muda no Weather Underground.",
  "addons.wundergroundRemoveStationTitle": "Apagar {station}?",
  "addons.wundergroundRetrieveApiKey": "Recuperar a sua chave API a partir deste link",
  "addons.wundergroundStationId": "ID da estação",
  "airQuality.adviceActivityGood": "Um dia ideal para atividades ao ar livre",
  "airQuality.adviceActivityHazardous": "Evite qualquer atividade física ao ar livre",
  "airQuality.adviceActivityLabel": "Atividade física",
  "airQuality.adviceActivityModerate": "Um bom dia para atividades ao ar livre",
  "airQuality.adviceActivitySensitive": "Considere atividades ao ar livre mais curtas e menos intensas",
  "airQuality.adviceActivityUnhealthy": "Reduza as atividades longas ou intensas e faça mais pausas",
  "airQuality.adviceActivityVeryUnhealthy": "Evite atividades longas ou intensas; considere passá-las para o interior",
  "airQuality.adviceGroupsGood": "Não são necessárias precauções especiais",
  "airQuality.adviceGroupsHazardous": "Fique no interior e limite a atividade",
  "airQuality.adviceGroupsLabel": "Grupos sensíveis",
  "airQuality.adviceGroupsModerate": "Pessoas especialmente sensíveis: atividades mais curtas e menos intensas",
  "airQuality.adviceGroupsSensitive": "Atividades ao ar livre mais curtas e menos intensas, com mais pausas",
  "airQuality.adviceGroupsUnhealthy": "Evite atividades longas ou intensas ao ar livre; considere passá-las para o interior",
  "airQuality.adviceGroupsVeryUnhealthy": "Evite qualquer atividade física ao ar livre; adie-a ou passe-a para o interior",
  "airQuality.adviceTimingLabel": "Quando sair",
  "airQuality.adviceTimingMorning": "De preferência de manhã: o ozono está mais baixo",
  "airQuality.airQuality": "Qualidade do ar",
  "airQuality.airQualityIndex": "Índice de qualidade do ar",
  "airQuality.aqiForecast": "Previsão da qualidade do ar",
  "airQuality.co2Fresh": "Fresco",
  "airQuality.co2GettingStale": "Ligeiramente abafado",
  "airQuality.co2Stale": "Abafado",
  "airQuality.dailyForecast": "Previsão diária",
  "airQuality.dominantPollutant": "Poluente dominante",
  "airQuality.expectedPeak": "Pico previsto",
  "airQuality.expectedPeakAt": "Pico previsto {value} · {band} · {time}",
  "airQuality.good": "Bom",
  "airQuality.goodDescription": "A qualidade do ar é considerada satisfatória, e a poluição do ar acarreta pouco ou nenhum risco",
  "airQuality.hazardous": "Perigoso",
  "airQuality.hazardousDescription": "Alerta de saúde: toda a gente pode experienciar efeitos sérios na saúde",
  "airQuality.indoorAirQuality": "Qualidade do ar interno",
  "airQuality.moderate": "Moderado",
  "airQuality.moderateDescription": "A qualidade do ar é aceitável; contudo, alguns poluentes podem ter um efeito moderado na saúde para um número muito reduzido de pessoas que são particularmente sensíveis a poluição do ar.",
  "airQuality.noForecastForLocation": "Não há previsão de qualidade do ar disponível para este local.",
  "airQuality.now": "Agora",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Poluentes",
  "airQuality.recommendations": "Recomendações",
  "airQuality.sensitiveUnhealthy": "Não saudável para grupos sensíveis",
  "airQuality.sensitiveUnhealthyDescription": "Membros de grupos sensíveis podem experienciar efeitos na saúde. O público em geral não será afetado provavelmente.",
  "airQuality.subIndex": "Subíndice AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Compreender o índice",
  "airQuality.unhealthy": "Não saudável",
  "airQuality.unhealthyDescription": "Toda a gente pode começar a experienciar efeitos na saúde; membros de grupos sensíveis podem experienciar efeitos mais sérios na saúde",
  "airQuality.veryUnhealthy": "Nada saudável",
  "airQuality.veryUnhealthyDescription": "Avisos de saúde para condições de emergência. Muito provavelmente toda a população será afetada.",
  "alerts.addAlert": "Adicionar alerta",
  "alerts.addCondition": "Adicionar condição",
  "alerts.alertAdded": "Alerta adicionado com sucesso",
  "alerts.alertAuthorizationNotice": "Os alertas funcionam apenas se autorizar a SmartMixin mostrar notificações",
  "alerts.alertDeleted": "Alerta apagado com sucesso",
  "alerts.alertName": "Nome de alerta",
  "alerts.alertWhen": "Eu quero ser alertado quando:",
  "alerts.aqiGreaterThan": "AQI superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior a {value}{unit}",
  "alerts.aqiLessThan": "AQI inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior a {value}{unit}",
  "alerts.atLeastOneCondition": "Necessita de adicionar pelo menos uma condição",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior a {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior a {value}{unit}",
  "alerts.conditions": "Condições",
  "alerts.conditionsDroppedOnStationChange": "Condições não suportadas por esta estação, removidas: {conditions}",
  "alerts.createAlert": "Criar alerta",
  "alerts.dailyPrecipitationGreaterThan": "Precipitação diária superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitação diária superior ao limiar de {value}{unit}",
  "alerts.deleteAlert": "Eliminar alerta",
  "alerts.deviceOnlyAlertNotice": "Os seus alertas ficam guardados apenas neste dispositivo. Entre para os associar à sua conta.",
  "alerts.editAlert": "Editar alerta",
  "alerts.editCondition": "Editar condição",
  "alerts.gustSpeedGreaterThan": "Rajada de vento superior a",
  "alerts.gustSpeedGreaterThanThreshold": "Rajada de vento superior a {value}{unit}",
  "alerts.gustSpeedLessThan": "Rajada de vento inferior a",
  "alerts.gustSpeedLessThanThreshold": "Rajada de vento inferior a {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índice de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índice de calor superior a {value}{unit}",
  "alerts.heatIndexLessThan": "Índice de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índice de calor inferior a {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior a {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior a {value}{unit}",
  "alerts.humidityGreaterThan": "Humidade superior a",
  "alerts.humidityGreaterThanThreshold": "Humidade superior a {value}{unit}",
  "alerts.humidityLessThan": "Humidade inferior a",
  "alerts.humidityLessThanThreshold": "Humidade inferior a {value}{unit}",
  "alerts.inProgress": "Em curso",
  "alerts.leafWetnessGreaterThan": "Molhamento foliar superior a",
  "alerts.leafWetnessGreaterThanThreshold": "Molhamento foliar superior a {value}{unit}",
  "alerts.leafWetnessLessThan": "Molhamento foliar inferior a",
  "alerts.leafWetnessLessThanThreshold": "Molhamento foliar inferior a {value}{unit}",
  "alerts.myAlerts": "Meus alertas",
  "alerts.noAlertsForStation": "Ainda não há alertas configurados para esta estação",
  "alerts.noConfiguredAlert": "Ainda não tem nenhum alerta configurado, adicione um",
  "alerts.noiseGreaterThan": "Ruído superior a",
  "alerts.noiseGreaterThanThreshold": "Ruído superior a {value}{unit}",
  "alerts.noiseLessThan": "Ruído inferior a",
  "alerts.noiseLessThanThreshold": "Ruído inferior a {value}{unit}",
  "alerts.noteOnConditions": "Note que o alerta é acionado quando todas as condições abaixo são verificadas",
  "alerts.noTriggerHistory": "Este alerta ainda não foi acionado.",
  "alerts.pm10GreaterThan": "PM 10 superior a",
  "alerts.pm10GreaterThanThreshold": "PM 10 superior a {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inferior a",
  "alerts.pm10LessThanThreshold": "PM 10 inferior a {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 superior a",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior a {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior a {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 superior a",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 superior a {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inferior a",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inferior a {value}{unit}",
  "alerts.postStormSummary": "Resumo da tempestade",
  "alerts.postStormSynopsisHelper": "Receberá uma notificação de resumo no final de cada tempestade de chuva.",
  "alerts.postStormSynopsisSoleCondition": "Um resumo pós-tempestade não pode ser combinado com outras condições.",
  "alerts.precipitationGreaterThan": "Precipitação horária superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitação horária superior ao limiar de {value}{unit}",
  "alerts.pressureGreaterThan": "Pressão atmosférica superior a",
  "alerts.pressureGreaterThanThreshold": "Pressão atmosférica superior a {value}{unit}",
  "alerts.pressureLessThan": "Pressão atmosférica inferior a",
  "alerts.pressureLessThanThreshold": "Pressão atmosférica inferior a {value}{unit}",
  "alerts.pushPromptAccept": "Ativar notificações",
  "alerts.pushPromptBody": "Os alertas da sua estação chegam como notificações. Ative-as para não perder nenhum.",
  "alerts.pushPromptBodyCreated": "O seu alerta foi guardado. Ative as notificações para que chegue até si quando disparar.",
  "alerts.pushPromptTitle": "Seja avisado quando os seus alertas dispararem",
  "alerts.rainRateGreaterThan": "Intensidade de chuva superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensidade de chuva superior ao limiar de {value}{unit}",
  "alerts.sensorNotReporting": "Este sensor não envia dados neste momento. O alerta será retomado quando voltar a enviar.",
  "alerts.soilMoistureGreaterThan": "Humidade do solo superior a",
  "alerts.soilMoistureGreaterThanThreshold": "Humidade do solo superior a {value}{unit}",
  "alerts.soilMoistureLessThan": "Humidade do solo inferior a",
  "alerts.soilMoistureLessThanThreshold": "Humidade do solo inferior a {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiação solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiação solar superior a {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiação solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiação solar inferior a {value}{unit}",
  "alerts.stationAlerts": "Alertas para esta estação",
  "alerts.stationNoLongerReports": "Esta estação já não envia dados, por isso este alerta não pode ser acionado.",
  "alerts.stormChartUnavailable": "O histórico de chuva desta tempestade não está disponível.",
  "alerts.stormDetail": "Resumo da tempestade",
  "alerts.stormDuration": "Duração",
  "alerts.stormEnd": "Fim",
  "alerts.stormPeakRate": "Intensidade máxima de chuva",
  "alerts.stormStart": "Início",
  "alerts.stormTotal": "Chuva total",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior a {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior a {value}{unit}",
  "alerts.thresholdOutOfRange": "Deve estar entre {min} e {max}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior a {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior a {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior a {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior a {value}{unit}",
  "alerts.triggerHistory": "Histórico do alerta",
  "alerts.uvGreaterThan": "Índice UV superior a",
  "alerts.uvGreaterThanThreshold": "Índice UV superior a {value}{unit}",
  "alerts.uvLessThan": "Índice UV inferior a",
  "alerts.uvLessThanThreshold": "Índice UV inferior a {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilidade superior a {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilidade inferior a {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilidade superior a",
  "alerts.visiblityLessThan": "Visibilidade inferior a",
  "alerts.whichMeasure": "Para que medida gostaria de ser alertado?",
  "alerts.whichModule": "Para que módulo gostaria de ser alertado?",
  "alerts.whichSensor": "Para que sensor gostaria de ser alertado?",
  "alerts.windChillGreaterThan": "Arrefecimento pelo vento superior a",
  "alerts.windChillGreaterThanThreshold": "Arrefecimento pelo vento superior a {value}{unit}",
  "alerts.windChillLessThan": "Arrefecimento pelo vento inferior a",
  "alerts.windChillLessThanThreshold": "Arrefecimento pelo vento inferior a {value}{unit}",
  "alerts.windSpeedGreaterThan": "Velocidade do vento superior a",
  "alerts.windSpeedGreaterThanThreshold": "Velocidade do vento superior a {value}{unit}",
  "alerts.windSpeedLessThan": "Velocidade do vento inferior a",
  "alerts.windSpeedLessThanThreshold": "Velocidade do vento inferior a {value}{unit}",
  "appUpdate.openInBrowser": "Abrir no navegador",
  "appUpdate.reload": "Recarregar",
  "appUpdate.update": "Atualizar",
  "appUpdate.updateAvailable": "Atualização disponível",
  "appUpdate.updateAvailableOpenAppStore": "Toque para abrir a App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Toque para abrir o Google Play",
  "appUpdate.updateAvailableVersion": "Atualização disponível: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Uma atualização da sua aplicação é requerida, vá para o Google Play para atualizar.",
  "appUpdate.upgradeRequiredIos": "Uma atualização da sua aplicação é requerida, vá para a App Store para atualizar.",
  "appUpdate.upgradeRequiredTitle": "Atualize o SmartMixin para continuar",
  "appUpdate.webUpdateAvailable": "Está disponível uma nova versão do SmartMixin. Recarregue a página para a utilizar.",
  "astral.aboveHorizonAllDay": "Acima do horizonte todo o dia",
  "astral.aboveTheHorizon": "acima do horizonte",
  "astral.apparentSize": "Diâmetro aparente",
  "astral.apparentSizeAcross": "{size} de diâmetro",
  "astral.astronomicalDawn": "Aurora astronómica",
  "astral.astronomicalDusk": "Crepúsculo astronómico",
  "astral.belowHorizonAllDay": "Abaixo do horizonte todo o dia",
  "astral.belowHorizonSince": "Abaixo do horizonte desde as {time}",
  "astral.belowHorizonSinceOn": "Abaixo do horizonte desde {day} às {time}",
  "astral.brightAllNight": "Lua brilhante toda a noite — nunca fica totalmente escuro",
  "astral.brightestMoment": "Momento mais claro",
  "astral.civilDawn": "Aurora civil",
  "astral.civilDusk": "Crepúsculo civil",
  "astral.darkSkyBetween": "Céu escuro {from} → {to}",
  "astral.darkSkyWindow": "Céu escuro {from} → {to} · {duration} sem Lua",
  "astral.dayLength": "Duração do dia",
  "astral.daylightThroughTheYear": "Duração do dia ao longo do ano",
  "astral.dayOfCycle": "dia {day} de {total}",
  "astral.doesNotOccurToday": "Hoje não ocorre",
  "astral.domeHint": "Arraste para percorrer a noite",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Nascer do sol mais cedo",
  "astral.earliestSunset": "Pôr do sol mais cedo",
  "astral.equinox": "Equinócio",
  "astral.equinoxIn": "Equinócio em {days, plural, one {# dia} other {# dias}}",
  "astral.evening": "Tarde",
  "astral.exactPhaseAt": "Exatamente às {time}",
  "astral.firstQuarter": "Quarto crescente",
  "astral.firstSunriseIn": "Primeiro nascer do sol em {days, plural, one {# dia} other {# dias}}",
  "astral.firstSunsetIn": "Primeiro pôr do sol em {days, plural, one {# dia} other {# dias}}",
  "astral.fullMoon": "Lua cheia",
  "astral.goldenHourBegins": "Início da hora dourada",
  "astral.goldenHourEnds": "Fim da hora dourada",
  "astral.highestPoint": "Ponto mais alto",
  "astral.inDays": "em {days, plural, one {# dia} other {# dias}}",
  "astral.lastQuarter": "Quarto minguante",
  "astral.latestSunrise": "Nascer do sol mais tardio",
  "astral.latestSunset": "Pôr do sol mais tardio",
  "astral.litShort": "Ilum.",
  "astral.longestDay": "Dia mais longo",
  "astral.lowestPoint": "Ponto mais baixo",
  "astral.maxAltitudeShort": "Máx.",
  "astral.midday": "Meio-dia",
  "astral.midnightSun": "Sol da meia-noite",
  "astral.midnightSunPeriod": "Sol da meia-noite",
  "astral.milestoneFootnotePolar": "Aqui o sol não nasce nem se põe durante {days, plural, one {# dia} other {# dias}} por ano, pelo que, em vez dos habituais extremos de nascer e pôr do sol, a lista mostra quando isso acontece.",
  "astral.milestoneFootnoteTemperate": "O pôr do sol mais cedo e o nascer do sol mais tardio não caem no dia mais curto — é a equação do tempo, não o solstício, que fixa essas duas datas.",
  "astral.moon": "Lua",
  "astral.moonAltitude": "Altura",
  "astral.moonDirection": "Azimute",
  "astral.moonDistance": "Distância",
  "astral.moonlessFor": "{duration} sem Lua",
  "astral.moonPhases": "Fases da lua",
  "astral.moonrise": "Nascer da lua",
  "astral.moonset": "Pôr da lua",
  "astral.moonUpAllNight": "A Lua está acima do horizonte toda a noite",
  "astral.moonWashesOutNight": "A Lua está acima do horizonte das {rise} às {set} e ilumina toda a noite",
  "astral.morning": "Manhã",
  "astral.nauticalDawn": "Aurora náutica",
  "astral.nauticalDusk": "Crepúsculo náutico",
  "astral.newMoon": "Lua nova",
  "astral.nextDay": "+1 dia",
  "astral.nextProperlyDarkNight": "Próxima noite realmente escura",
  "astral.nextRise": "próximo nascer às {time}",
  "astral.nextRiseOn": "próximo nascer {day} às {time}",
  "astral.nextSevenNights": "As próximas sete noites",
  "astral.nightDate": "Data",
  "astral.noAstronomicalDarknessTonight": "Sem noite astronómica esta noite",
  "astral.noDarkNightAhead": "Nenhuma nas próximas duas semanas",
  "astral.noStationLocation": "Localização desconhecida",
  "astral.noStationLocationDescription": "Esta estação não tem nenhuma posição registada, por isso não é possível calcular o sol e a lua para ela.",
  "astral.noSunriseToday": "Hoje o Sol não nasce",
  "astral.nowAtBearing": "agora {altitude} · azimute {direction}",
  "astral.observing": "Observação",
  "astral.ofDaylightLeft": "de luz do dia restante",
  "astral.overTheNextThreeWeeks": "nas próximas 3 semanas",
  "astral.percentLit": "{percent} iluminada",
  "astral.polarNight": "Noite polar",
  "astral.polarNightPeriod": "Noite polar",
  "astral.rightNow": "Agora",
  "astral.riseShort": "Nascer",
  "astral.setShort": "Pôr",
  "astral.shortestDay": "Dia mais curto",
  "astral.solarNoon": "Meio-dia solar",
  "astral.solstice": "Solstício",
  "astral.sunBelowHorizon": "Sol a {degrees}° abaixo do horizonte",
  "astral.sunEvents": "Eventos solares",
  "astral.sunNeverDarkEnough": "O Sol nunca desce 18° abaixo do horizonte",
  "astral.sunNeverSets": "O Sol não se põe",
  "astral.sunrise": "Nascer do sol",
  "astral.sunriseAndSunset": "Nascer do sol e pôr do sol",
  "astral.sunriseAt": "Nascer do sol às {time}",
  "astral.sunset": "Pôr do sol",
  "astral.sunsetAt": "Pôr do sol às {time}",
  "astral.thisYearAtNorth": "Este ano a {degrees}° N",
  "astral.thisYearAtSouth": "Este ano a {degrees}° S",
  "astral.tonight": "Esta noite",
  "astral.twilightAllNight": "Crepúsculo toda a noite — nunca fica totalmente escuro",
  "astral.upFor": "{duration} acima do horizonte",
  "astral.usableLight": "Luz útil",
  "astral.vsAverage": "{percent} face à média",
  "astral.vsYesterday": "em relação a ontem",
  "astral.waningCrescent": "Lua minguante",
  "astral.waningGibbous": "Lua gibosa minguante",
  "astral.waxingCrescent": "Lua crescente",
  "astral.waxingGibbous": "Lua gibosa crescente",
  "astral.whereToLook": "Para onde olhar",
  "astral.withoutTheMoon": "{duration} sem Lua",
  "auth.alreadyHaveAccount": "Já tem uma conta?",
  "auth.authContainerTagline": "O seu painel meteorológico pessoal. Conecte as suas estações e obtenha dados em tempo real na ponta dos dedos.",
  "auth.backToLogin": "Voltar ao login",
  "auth.checkYourEmail": "Verifique o seu email",
  "auth.continueWithApple": "Continuar com Apple",
  "auth.continueWithFacebook": "Continuar com Facebook",
  "auth.continueWithGoogle": "Continuar com Google",
  "auth.email": "Endereço de email",
  "auth.emailRequiredLoginFacebook": "A permissão de email é requerida.",
  "auth.emailVerification": "Verificação de e-mail",
  "auth.emailVerificationFailure": "Ocorreu um problema com a sua verificação de email.",
  "auth.emailVerificationSuccess": "O seu email foi verificado com sucesso.",
  "auth.firstName": "Nome",
  "auth.forgotPassword": "Esqueceu a sua palavra-passe?",
  "auth.forgotPasswordSubtitle": "Insira o seu email e enviaremos um link para redefinir a sua palavra-passe.",
  "auth.lastName": "Apelido",
  "auth.login": "Entrar",
  "auth.loginSubtitle": "Bem-vindo de volta! Por favor, insira os seus dados.",
  "auth.loginToSmartMixinDescription": "Inicie sessão no SmartMixin para aceder às suas estações meteorológicas, ver análises e gerir o seu painel meteorológico pessoal.",
  "auth.logout": "Sair",
  "auth.logoutConfirmation": "Deseja sair?",
  "auth.noAccountYet": "Ainda não tem uma conta?",
  "auth.or": "ou",
  "auth.password": "Palavra-passe",
  "auth.passwordReset": "Redefinição de palavra-passe",
  "auth.passwordResetSuccess": "A sua palavra-passe foi atualizada com sucesso.",
  "auth.register": "Criar conta",
  "auth.registerDescription": "Crie uma conta SmartMixin gratuita para conectar as suas estações meteorológicas, acompanhar dados do tempo e aceder a ferramentas de análise poderosas.",
  "auth.registerSubtitle": "Crie a sua conta para começar.",
  "auth.restorePassword": "Restaurar palavra-passe",
  "auth.restorePasswordSuccess": "Nós enviámos-lhe um link de redefinição de palavra-passe para {emailAddress} com mais instruções.",
  "auth.sendReset": "Enviar instruções de redefinição",
  "auth.signInRowDescription": "Mantenha os seus locais, estações e alertas em todos os seus dispositivos",
  "auth.signInRowTitle": "Entrar ou criar conta",
  "auth.signInWithApple": "Iniciar sessão com a Apple",
  "auth.socialAccount": "ou utilize a sua conta",
  "auth.staffVerificationCode": "Código de verificação",
  "auth.staffVerificationExpiresIn": "Verificado. Expira em {duration}.",
  "auth.staffVerificationInvalidCode": "Código incorreto. Tente novamente.",
  "auth.staffVerificationLoginAsStopped": "O Login As foi interrompido: introduza um código de verificação no ecrã Debug para continuar.",
  "auth.staffVerificationNotEnrolled": "Não existe nenhuma aplicação de autenticação configurada na sua conta. Adicione uma nas definições de segurança do back office.",
  "auth.staffVerificationPasskey": "Verificar com chave de acesso",
  "auth.staffVerificationPasskeyExpired": "O pedido da chave de acesso expirou. Tente novamente.",
  "auth.staffVerificationPasskeyFailed": "A verificação com chave de acesso falhou. Tente novamente ou introduza um código.",
  "auth.staffVerificationPasskeyNotEnrolled": "Não existe nenhuma chave de acesso da sua conta disponível neste telemóvel. Adicione uma a partir deste telemóvel nas definições de segurança do back office, ou introduza um código.",
  "auth.staffVerificationPasskeySetupLink": "Adicionar uma chave de acesso",
  "auth.staffVerificationPasskeyUnavailable": "Não é possível usar chaves de acesso aqui. Em alternativa, introduza um código.",
  "auth.staffVerificationPrompt": "Introduza o código de 6 dígitos da sua aplicação de autenticação, ou um código de recuperação, para usar o Login As e a pesquisa de utilizadores.",
  "auth.staffVerificationPromptPasskey": "Use a sua chave de acesso, ou introduza o código de 6 dígitos da sua aplicação de autenticação ou um código de recuperação, para usar o Login As e a pesquisa de utilizadores.",
  "auth.staffVerificationSetupLink": "Adicionar uma aplicação de autenticação",
  "auth.staffVerificationSubmit": "Verificar",
  "auth.staffVerificationTitle": "Verificação da equipa",
  "calendar.afternoon": "Tarde",
  "calendar.april": "Abril",
  "calendar.august": "Agosto",
  "calendar.changePeriod": "Período: {period}. Alterar período",
  "calendar.currentDay": "Hoje",
  "calendar.dateFormat": "Formato de data",
  "calendar.day": "Dia",
  "calendar.december": "Dezembro",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Anos anteriores",
  "calendar.endTime": "Fim",
  "calendar.evening": "Noite",
  "calendar.february": "Fevereiro",
  "calendar.goToNextDay": "Dia seguinte",
  "calendar.goToNextMonth": "Mês seguinte",
  "calendar.goToNextWeek": "Semana seguinte",
  "calendar.goToNextYear": "Ano seguinte",
  "calendar.goToPreviousDay": "Dia anterior",
  "calendar.goToPreviousMonth": "Mês anterior",
  "calendar.goToPreviousWeek": "Semana anterior",
  "calendar.goToPreviousYear": "Ano anterior",
  "calendar.hour": "Hora",
  "calendar.hoursCount": "{count, plural, one {# hora} other {# horas}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Janeiro",
  "calendar.july": "Julho",
  "calendar.june": "Junho",
  "calendar.last12Hours": "Últimas 12 horas",
  "calendar.last24Hours": "Últimas 24 horas",
  "calendar.last24HoursTo": "24 h até às {time}",
  "calendar.last24HoursToYesterday": "24 h até ontem às {time}",
  "calendar.last30Days": "Últimos 30 dias",
  "calendar.last3Hours": "Últimas 3 horas",
  "calendar.last6Hours": "Últimas 6 horas",
  "calendar.last7Days": "Últimos 7 dias",
  "calendar.lastHour": "Última hora",
  "calendar.laterYears": "Anos posteriores",
  "calendar.march": "Março",
  "calendar.max": "Max",
  "calendar.may": "Maio",
  "calendar.month": "Mês",
  "calendar.monthTotal": "Este mês",
  "calendar.morning": "Manhã",
  "calendar.nextHours": "Horas seguintes",
  "calendar.night": "Madrugada",
  "calendar.november": "Novembro",
  "calendar.october": "Outubro",
  "calendar.oneDay": "1 dia",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mês",
  "calendar.oneWeek": "1 semana",
  "calendar.periodRangeSpoken": "de {start} a {end}",
  "calendar.previous24Hours": "As 24 horas anteriores",
  "calendar.previous30Days": "Os 30 dias anteriores",
  "calendar.previous7Days": "Os 7 dias anteriores",
  "calendar.previousDay": "Dia anterior",
  "calendar.previousHours": "Horas anteriores",
  "calendar.previousMonth": "Mês anterior",
  "calendar.previousWeek": "Semana anterior",
  "calendar.previousYear": "Ano anterior",
  "calendar.sameDayLastYear": "Mesmo dia do ano passado",
  "calendar.sameMonthLastYear": "Mesmo mês do ano passado",
  "calendar.selectADate": "Selecione uma data",
  "calendar.selectAggregation": "Selecionar o valor exibido",
  "calendar.selectAMonth": "Selecione um mês",
  "calendar.selectAYear": "Selecione um ano",
  "calendar.selectGranularity": "Selecionar granularidade",
  "calendar.selectPeriod": "Selecione um período",
  "calendar.september": "Setembro",
  "calendar.sixHours": "6 horas",
  "calendar.startTime": "Início",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 horas",
  "calendar.timezone": "Fuso horário",
  "calendar.today": "Hoje",
  "calendar.untilChanged": "Até mudar",
  "calendar.untilTime": "Até {time}",
  "calendar.untilTodayAt": "Até hoje às {time}",
  "calendar.untilTomorrowAt": "Até amanhã às {time}",
  "calendar.use24HourFormat": "Utilizar o formato 24 horas",
  "calendar.week": "Semana",
  "calendar.year": "Ano",
  "calendar.yearToDate": "Este ano",
  "calendar.yesterday": "Ontem",
  "charts.averageOverThePeriod": "Média ao longo do período",
  "charts.calendarView": "Visualização de calendário",
  "charts.charts": "Gráficos",
  "charts.chartView": "Visualização de gráfico",
  "charts.comparison": "Comparação",
  "charts.customizeComparisonMetrics": "Personalizar métricas",
  "charts.customizeComparisonMetricsDescription": "Arraste os itens para reordenar suas métricas de comparação. Toque no ícone de olho para mostrar ou ocultar métricas.",
  "charts.loading": "A carregar o gráfico",
  "charts.maxOverThePeriod": "Máximo ao longo do período",
  "charts.measureToDisplay": "Medição a exibir",
  "charts.minMaxRange": "Mín. / Máx.",
  "charts.noDataForThisPeriod": "Sem dados para este período",
  "charts.observations": "Observações",
  "charts.observedTemperature": "Temperatura observada",
  "charts.seriesTableDate": "Data",
  "charts.showComparison": "Mostrar comparação",
  "charts.stationComparison": "Comparação de estações",
  "charts.stationComparisonDescription": "Permite comparar dados meteorológicos históricos com os de outra estação.",
  "charts.sumOverThePeriod": "Acumulado ao longo do período",
  "charts.tableLabel": "Tabela de {chart}",
  "charts.toggleSeries": "Mostrar ou ocultar {series}",
  "charts.viewAsChart": "Gráfico",
  "charts.viewAsList": "Lista",
  "charts.viewAsPeriods": "Períodos",
  "charts.viewAsTable": "Tabela",
  "charts.viewLabel": "Vista de {chart}",
  "common.add": "Adicionar",
  "common.altitude": "Altitude",
  "common.analysis": "Análise",
  "common.average": "Média",
  "common.back": "Voltar",
  "common.backToHome": "Voltar ao início",
  "common.cancel": "Cancelar",
  "common.cannotBeEmpty": "Este campo não pode estar vazio.",
  "common.clearSearch": "Limpar pesquisa",
  "common.close": "Fechar",
  "common.dailyForecast": "Previsão diária",
  "common.default": "Padrão",
  "common.delete": "Apagar",
  "common.details": "Detalhes",
  "common.edit": "Editar",
  "common.exitFullscreen": "Sair do ecrã inteiro",
  "common.forecast": "Previsão",
  "common.frequency": "Frequência",
  "common.full": "Completo",
  "common.fullscreen": "Ecrã inteiro",
  "common.help": "Ajuda",
  "common.hidden": "Ocultos",
  "common.high": "Alto",
  "common.iDontKnowYet": "Eu ainda não sei",
  "common.indoor": "Interior",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Última atualização",
  "common.low": "Baixo",
  "common.mapUnavailable": "Mapa indisponível",
  "common.maximum": "Máximo",
  "common.medium": "Médio",
  "common.minimum": "Mínimo",
  "common.more": "Mais",
  "common.moreInformation": "Mais informação",
  "common.moveDown": "Mover para baixo",
  "common.moveUp": "Mover para cima",
  "common.no": "Não",
  "common.noAccountNeeded": "Sem necessidade de conta",
  "common.noItemsAvailable": "Nenhum item disponível",
  "common.nothingSelected": "Nenhuma seleção",
  "common.notNow": "Agora não",
  "common.now": "Agora",
  "common.openSettings": "Abra as configurações",
  "common.outdoor": "Exterior",
  "common.pageNotFound": "Página não encontrada",
  "common.pageNotFoundDescription": "A página que procura não existe ou foi movida.",
  "common.rain": "Chuva",
  "common.reorderCancel": "Movimento cancelado: {item}. De volta à posição {position} de {count}.",
  "common.reorderEnd": "Item solto: {item}. Posição {position} de {count}.",
  "common.reorderInstructions": "Para mover este item, pressione Espaço ou Enter, escolha o lugar dele com as setas para cima e para baixo e pressione Espaço ou Enter de novo para soltá-lo, ou Esc para cancelar.",
  "common.reorderOver": "{item}: agora na posição {position} de {count}.",
  "common.reorderStart": "Item selecionado: {item}. Posição {position} de {count}.",
  "common.search": "Pesquisar",
  "common.share": "Partilhar",
  "common.shareImageFailed": "Não foi possível partilhar a imagem",
  "common.shareYourWeather": "Partilhe o seu tempo",
  "common.skip": "Saltar",
  "common.snackbarWithAction": "{message}. Ação: {action}",
  "common.unknown": "Desconhecido",
  "common.validate": "Confirmar",
  "common.validEmail": "Um endereço de email válido é requerido.",
  "common.very_low": "Muito baixo",
  "common.weatherObservations": "Observações meteorológicas",
  "common.welcome": "Bem-vindo à SmartMixin!",
  "common.wind": "Vento",
  "common.yes": "Sim",
  "common.zoomImage": "Ampliar imagem",
  "compass.E": "E",
  "compass.E_long": "Este",
  "compass.ENE": "ENE",
  "compass.ENE_long": "Este-nordeste",
  "compass.ESE": "ESE",
  "compass.ESE_long": "Este-sudeste",
  "compass.N": "N",
  "compass.N_long": "Norte",
  "compass.NE": "NE",
  "compass.NE_long": "Nordeste",
  "compass.NNE": "NNE",
  "compass.NNE_long": "Norte-nordeste",
  "compass.NNW": "NNO",
  "compass.NNW_long": "Norte-noroeste",
  "compass.NW": "NO",
  "compass.NW_long": "Noroeste",
  "compass.S": "S",
  "compass.S_long": "Sul",
  "compass.SE": "SE",
  "compass.SE_long": "Sudeste",
  "compass.SSE": "SSE",
  "compass.SSE_long": "Sul-sudeste",
  "compass.SSW": "SSO",
  "compass.SSW_long": "Sul-sudoeste",
  "compass.SW": "SO",
  "compass.SW_long": "Sudoeste",
  "compass.W": "O",
  "compass.W_long": "Oeste",
  "compass.WNW": "ONO",
  "compass.WNW_long": "Oeste-noroeste",
  "compass.WSW": "OSO",
  "compass.WSW_long": "Oeste-sudoeste",
  "dashboard.currentObservations": "Observações atuais",
  "dashboard.currentRainEvent": "Evento de chuva atual",
  "dashboard.currentWeatherConditions": "Condições atuais",
  "dashboard.customizeDashboard": "Personalizar",
  "dashboard.customizeDashboardDescription": "Arraste os itens para reordenar o seu painel. Toque no ícone do olho para mostrar ou ocultar secções.",
  "dashboard.customizeNetatmoDescription": "Arraste os módulos para os reordenar dentro de Exterior ou Interior. Toque no ícone do olho para mostrar ou ocultar um módulo.",
  "dashboard.customizeNetatmoPublicDescription": "Arraste os módulos para os reordenar. Toque no ícone do olho para mostrar ou ocultar um módulo.",
  "dashboard.dashboard": "Painel de controlo",
  "dashboard.dayRangeExpected": "{value} previsto às {time}",
  "dashboard.dayRangeReached": "{value} às {time}",
  "dashboard.dayRangeSteady": "Estável em {value} o dia todo",
  "dashboard.hiddenSensors": "Sensores ocultos",
  "dashboard.hideSensor": "Ocultar {sensor}",
  "dashboard.lastRainEvent": "Último evento de chuva",
  "dashboard.lastVisibleSensor": "Pelo menos um sensor precisa continuar visível.",
  "dashboard.manageSensors": "Gerir sensores",
  "dashboard.manageSensorsDescription": "Arraste itens para reordenar os sensores. Toque no ícone do olho para mostrar ou ocultar sensores. Toque num nome para o renomear.",
  "dashboard.manageSensorsDescriptionWeb": "Clique no lápis para renomear um sensor, arraste a alça para reordenar a lista e clique no olho para ocultá-lo ou mostrá-lo.",
  "dashboard.moveSensor": "Mover {sensor}",
  "dashboard.pressureSummary": "Síntese de pressão",
  "dashboard.rainEvents": "Eventos de chuva",
  "dashboard.rainSummary": "Resumo da precipitação",
  "dashboard.renameSensor": "Renomear {sensor}",
  "dashboard.shareOutdoorMeasures": "Partilhe as suas medições exteriores",
  "dashboard.shareOutdoorMeasuresDescription": "Participe na comunidade SmartMixin tornando as suas medições visíveis para os outros. As medições interiores nunca serão partilhadas.",
  "dashboard.showSensor": "Mostrar {sensor}",
  "dashboard.temperatureSummary": "Resumo da temperatura",
  "dashboard.useDefaultSensorName": "Usar o nome padrão",
  "dashboard.windSummary": "Síntese do vento",
  "devices.batteryLevel": "Nível de bateria",
  "devices.firmwareVersion": "Versão do firmware",
  "devices.moduleCount": "{count, plural, one {# módulo} other {# módulos}}",
  "devices.moduleType": "Tipo de módulo",
  "devices.noNetatmoWeatherStationYet": "Ainda não tem uma estação meteorológica Netatmo.",
  "devices.noOutdoorModule": "Não há módulo exterior funcional para esta estação.",
  "devices.notReachable": "Sem ligação",
  "devices.serialNumber": "Número de série",
  "devices.signalAverage": "Médio",
  "devices.signalBad": "Fraco",
  "devices.signalGood": "Bom",
  "devices.signalStrength": "Força do sinal",
  "devices.signalUnknown": "Desconhecido",
  "devices.visitNetatmoWebsite": "Visitar o website Netatmo",
  "devices.wifiStrength": "Força de sinal Wi-Fi",
  "forecastMaps.addColor": "Adicionar cor",
  "forecastMaps.addLayer": "Adicionar camada",
  "forecastMaps.autoDescription": "O melhor disponível para esta vista",
  "forecastMaps.autoDescriptionFree": "Sem Premium: {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "A mostrar {model}: {previous} cobre {coverage, number, percent} desta vista",
  "forecastMaps.backToMaps": "Voltar aos mapas",
  "forecastMaps.build": "Gerar",
  "forecastMaps.buildCompleted": "Geração concluída",
  "forecastMaps.builderMetaDescription": "Componha mapas de previsão personalizados a partir das camadas dos modelos meteorológicos.",
  "forecastMaps.builderTitle": "Criador de mapas",
  "forecastMaps.buildFailed": "A geração falhou. Tente novamente.",
  "forecastMaps.buildNotPossible": "Este mapa ainda não pode ser gerado — não há dados de previsão disponíveis.",
  "forecastMaps.buildProgress": "A renderizar… {completed}/{total} passos",
  "forecastMaps.buildStarting": "A iniciar a geração…",
  "forecastMaps.byModel": "Por modelo",
  "forecastMaps.byZone": "Por zona",
  "forecastMaps.colormap": "Paleta de cores",
  "forecastMaps.colormapCustom": "Cores personalizadas",
  "forecastMaps.colormapGroupDomain": "Paletas meteorológicas",
  "forecastMaps.colormapGroupMatplotlib": "Paletas científicas",
  "forecastMaps.colorStop": "Cor {position}",
  "forecastMaps.configUnavailable": "Este mapa de previsão não está disponível. Em vez dele, é mostrado {name}.",
  "forecastMaps.contourLevels": "Níveis de contorno",
  "forecastMaps.countryCanada": "Canadá",
  "forecastMaps.countryFrance": "França",
  "forecastMaps.countryGermany": "Alemanha",
  "forecastMaps.countryItaly": "Itália",
  "forecastMaps.countryScandinavia": "Escandinávia",
  "forecastMaps.countrySpain": "Espanha",
  "forecastMaps.countrySwitzerland": "Suíça",
  "forecastMaps.countryUnitedStates": "Estados Unidos",
  "forecastMaps.coverageUnknown": "Área desconhecida",
  "forecastMaps.coversView": "Cobre {coverage, number, percent} desta vista",
  "forecastMaps.customColormapMinColors": "Uma paleta personalizada precisa de pelo menos duas cores",
  "forecastMaps.customExtent": "Extensão personalizada",
  "forecastMaps.displayName": "Nome de exibição",
  "forecastMaps.downscaling": "Fator de espaçamento das barbelas",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Desenhar área",
  "forecastMaps.east": "Este",
  "forecastMaps.extentDrawHint": "Arraste no mapa para desenhar a área",
  "forecastMaps.extentInvalid": "O oeste deve ser menor que o este e o sul menor que o norte",
  "forecastMaps.frameTime": "Hora da previsão",
  "forecastMaps.height": "Altura (polegadas)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "Nesta área",
  "forecastMaps.invalidHexColor": "Cor inválida — use #RRGGBB",
  "forecastMaps.layerHasErrors": "Esta camada tem erros",
  "forecastMaps.layers": "Camadas",
  "forecastMaps.layerTypeBarbs": "Barbelas de vento",
  "forecastMaps.layerTypeContour": "Linhas de contorno",
  "forecastMaps.layerTypeFilledContour": "Contornos preenchidos",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Campo vetorial",
  "forecastMaps.leave": "Sair",
  "forecastMaps.levelsCount": "Quantidade",
  "forecastMaps.levelsInvalid": "Níveis de contorno inválidos",
  "forecastMaps.levelsModeArange": "Passo fixo",
  "forecastMaps.levelsModeExplicit": "Valores explícitos",
  "forecastMaps.levelsModeLinspace": "Espaçamento uniforme (quantidade)",
  "forecastMaps.levelsStep": "Passo",
  "forecastMaps.levelsValues": "Valores",
  "forecastMaps.levelsValuesHint": "Separados por vírgulas, ascendentes",
  "forecastMaps.loadingMaps": "A carregar os mapas…",
  "forecastMaps.localTimeHint": "Apresentado na sua hora local",
  "forecastMaps.lockedConfig": "{model} é um modelo Premium. Em vez dele, é mostrado {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Descrição",
  "forecastMaps.mapName": "Nome do mapa",
  "forecastMaps.mapNameRequired": "Introduza um nome",
  "forecastMaps.mapSettings": "Definições do mapa",
  "forecastMaps.maxLayersReached": "Este mapa atingiu o máximo de {max} camadas.",
  "forecastMaps.maxValue": "Valor máximo",
  "forecastMaps.memoryBudgetExceeded": "A resolução excede o orçamento de renderização — reduza o DPI ou a altura",
  "forecastMaps.memoryBudgetUsage": "Orçamento de renderização: {percent}%",
  "forecastMaps.metaDescription": "Mapas de previsão animados gerados a partir dos modelos meteorológicos.",
  "forecastMaps.metric": "Medida",
  "forecastMaps.metricRequired": "Selecione uma medida",
  "forecastMaps.metricUnavailable": "Indisponível para este modelo",
  "forecastMaps.minBelowMax": "O mínimo deve ser menor que o máximo",
  "forecastMaps.minMaxRequired": "Os valores mínimo e máximo são obrigatórios para este tipo de camada",
  "forecastMaps.minValue": "Valor mínimo",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} cobre {coverage, number, percent} desta vista",
  "forecastMaps.modelNoRun": "Ainda não há nenhuma execução concluída",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.nanClipToMin": "Limitar ao mínimo",
  "forecastMaps.nanMask": "Mascarar",
  "forecastMaps.nanPolicy": "Dados em falta",
  "forecastMaps.nanSkip": "Ignorar",
  "forecastMaps.noCompletedRun": "Este mapa ainda não foi gerado. Volte a verificar em breve.",
  "forecastMaps.noLayers": "Ainda não há camadas. Adicione uma camada para começar.",
  "forecastMaps.noMapsAvailable": "Ainda não há mapas de previsão disponíveis.",
  "forecastMaps.north": "Norte",
  "forecastMaps.opacity": "Opacidade",
  "forecastMaps.openAsAnimation": "Abrir como animação",
  "forecastMaps.otherAreas": "Outras áreas",
  "forecastMaps.outsideArea": "Não cobre esta área",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Reproduzir",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Não foi possível carregar a previsão para este ponto.",
  "forecastMaps.pointValueLoading": "A carregar a previsão…",
  "forecastMaps.pointValueUnavailable": "Sem dados para esta hora.",
  "forecastMaps.premiumModelForView": "{model} cobre esta vista",
  "forecastMaps.premiumRequired": "Os mapas de previsão requerem Premium",
  "forecastMaps.preview": "Pré-visualização",
  "forecastMaps.previewEmptyHint": "Configure pelo menos uma camada válida para renderizar uma pré-visualização.",
  "forecastMaps.previewFailed": "A pré-visualização falhou",
  "forecastMaps.previewHour": "Hora de previsão",
  "forecastMaps.previewRendering": "A renderizar a pré-visualização…",
  "forecastMaps.projection": "Projeção",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Estereográfica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "América do Norte",
  "forecastMaps.removeColor": "Remover cor",
  "forecastMaps.removeLayer": "Remover camada",
  "forecastMaps.retry": "Tentar novamente",
  "forecastMaps.run": "Execução: {run}",
  "forecastMaps.runNotDisplayable": "Esta execução não pode ser mostrada no mapa interativo.",
  "forecastMaps.save": "Guardar",
  "forecastMaps.selectExtentOnMap": "Selecionar área no mapa",
  "forecastMaps.showArea": "Mostrar área",
  "forecastMaps.showAreaOf": "Mostrar área, {model}",
  "forecastMaps.south": "Sul",
  "forecastMaps.switchToModel": "Mudar para {model}",
  "forecastMaps.title": "Mapas de previsão",
  "forecastMaps.uMetric": "Componente U",
  "forecastMaps.unitConversion": "Conversão de unidades",
  "forecastMaps.unitNone": "Nenhuma",
  "forecastMaps.unsavedChangesBody": "Tem alterações não guardadas. Sair e descartá-las?",
  "forecastMaps.unsavedChangesTitle": "Alterações não guardadas",
  "forecastMaps.useCurrentView": "Usar vista atual",
  "forecastMaps.useModelDomain": "Desativado: é usado o domínio completo do modelo",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "As medidas U e V devem ser diferentes",
  "forecastMaps.valueBetween": "Deve estar entre {min} e {max}",
  "forecastMaps.variable": "Variável",
  "forecastMaps.variableMissing": "{variable} não disponível",
  "forecastMaps.variableOnlyFrom": "{variable} só vem do {model}",
  "forecastMaps.vectorLayerFronts": "Frentes",
  "forecastMaps.vectorLayerIsobars": "Isóbaras",
  "forecastMaps.vectorLayerWindBarbs": "Barbelas de vento",
  "forecastMaps.viewMap": "Ver mapa",
  "forecastMaps.vMetric": "Componente V",
  "forecastMaps.west": "Oeste",
  "forecastMaps.windAnimation": "Animação do vento",
  "forecastMaps.windAnimationReduceMotion": "Desativada enquanto o seu dispositivo estiver configurado para reduzir o movimento",
  "forecastModels.addForecastModel": "Adicionar um modelo",
  "forecastModels.atYourStations": "Disponíveis nas suas estações",
  "forecastModels.comparisonLoadError": "Não foi possível carregar a comparação de modelos meteorológicos",
  "forecastModels.coverageLoading": "A calcular que estações cada modelo abrange…",
  "forecastModels.description_AROME": "Modelo de alta resolução com resolução de convecção da Météo France sobre a Europa Ocidental a 1,3 km. O melhor da categoria para previsões de curto prazo em França; atualizado a cada três horas.",
  "forecastModels.description_ARPEGE_EU": "O domínio aninhado europeu do modelo ARPEGE da Météo France com resolução de 10 km. Previsões de médio prazo sobre a Europa, atualizadas quatro vezes por dia.",
  "forecastModels.description_ARPEGE_GLOBAL": "Modelo global numérico de previsão meteorológica da Météo France com resolução de 25 km, até cerca de 4 dias. Atualizado quatro vezes por dia.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI da DMI: um modelo com resolução de convecção sobre o noroeste da Europa — Dinamarca, Benelux, Irlanda, Reino Unido e Escandinávia — com resolução de 2 km até 60 horas, atualizado oito vezes por dia. Contém dados abertos da DMI modificados (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (Sistema Global de Previsão Determinística) da Environment Canada: um modelo mundial de médio prazo com resolução de 15 km até 10 dias, atualizado duas vezes por dia.",
  "forecastModels.description_EC_HRDPS": "Sistema Determinístico de Previsão de Alta Resolução da Environment Canada: um modelo com resolução de convecção sobre o Canadá e o norte dos Estados Unidos com resolução de 2,5 km até 48 horas, atualizado quatro vezes por dia.",
  "forecastModels.description_EC_RDPS": "Sistema Regional Determinístico de Previsão da Environment Canada: um modelo de médio prazo sobre a América do Norte com resolução de 10 km, atualizado quatro vezes por dia.",
  "forecastModels.description_ECMWF_HRES": "O modelo de alta resolução (IFS) do Centro Europeu de Previsões Meteorológicas a Médio Prazo, amplamente considerado o principal sistema de previsão global do mundo. Cobre todo o planeta com resolução de 25 km até 15 dias, atualizado quatro vezes por dia. Contém dados abertos do ECMWF modificados (CC BY 4.0).",
  "forecastModels.description_GFS": "O modelo global emblemático de médio prazo da NOAA. Cobre todo o planeta com resolução de 25 km até 16 dias, atualizado quatro vezes por dia.",
  "forecastModels.description_HRRR_CONUS": "O High-Resolution Rapid Refresh da NOAA: um modelo com resolução de convecção sobre os Estados Unidos continentais a 3 km de resolução, atualizado a cada hora. Mais adequado para previsões de muito curto prazo de trovoadas e tempo severo.",
  "forecastModels.description_ICON": "O modelo global ICON do DWD com resolução de 13 km que cobre todo o planeta até 7,5 dias, atualizado quatro vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I da ItaliaMeteo, operado em conjunto com a ARPAE: um modelo com resolução de convecção sobre a Itália com resolução de 2,2 km até 72 horas, atualizado duas vezes por dia. Contém dados abertos da ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "A execução de controlo do ICON-CH1-EPS da MeteoSwiss: um modelo com resolução de convecção sobre os Alpes com resolução de 1 km até 33 horas, atualizado a cada três horas.",
  "forecastModels.description_ICON_CH2": "A execução de controlo do ICON-CH2-EPS da MeteoSwiss: um modelo com resolução de convecção sobre os Alpes — Suíça e a região alpina circundante — com resolução de 2,1 km até 120 horas, atualizado quatro vezes por dia.",
  "forecastModels.description_ICON_DE": "Modelo de alta resolução com resolução de convecção do DWD sobre a Alemanha e países vizinhos a 2,2 km de resolução. Previsões de curto prazo atualizadas duas vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "O domínio aninhado europeu do modelo ICON do DWD com resolução de 7 km cobrindo a Europa e o Atlântico Norte. Previsões de médio prazo atualizadas quatro vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "O serviço aberto de previsão meteorológica do Instituto Meteorológico Norueguês, combinando modelos nórdicos de alta resolução com dados do ECMWF para fornecer previsões mundiais até 10 dias.",
  "forecastModels.description_MF_AROME_ANTILLES": "Domínio aninhado do AROME sobre as Antilhas francesas (Guadalupe, Martinica) com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "forecastModels.description_MF_AROME_GUYANE": "Domínio aninhado do AROME sobre a Guiana Francesa com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Domínio aninhado do AROME sobre a Nova Caledónia com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Domínio aninhado do AROME sobre a Polinésia Francesa com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Domínio aninhado do AROME sobre Reunião e Mayotte com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "forecastModels.description_RRFS_CONUS": "O Rapid Refresh Forecast System da NOAA sobre os Estados Unidos continentais com 3 km de resolução. Previsões horárias atualizadas oito vezes por dia, até 84 horas nas quatro passagens principais e 18 horas nas restantes.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "O Rapid Refresh Forecast System da NOAA cobrindo toda a América do Norte com 13 km de resolução. Previsões horárias até 84 horas, atualizadas quatro vezes por dia.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "A previsão emblemática da SmartMixin. Para cada hora na sua localização, escolhemos o melhor modelo disponível — normalmente um modelo regional de alta resolução onde existe um (AROME em França, ICON-D2 na Alemanha, HRRR nos Estados Unidos, ARPEGE Europe em todo o continente…) e recorremos a um modelo global noutros locais — preenchendo depois quaisquer lacunas a partir de fontes vizinhas. O resultado é uma única previsão contínua que cobre qualquer lugar do mundo até 14 dias, atualizada automaticamente sempre que algum dos modelos subjacentes é atualizado.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Previsão global proprietária da Weatherflow que combina vários modelos numéricos de previsão meteorológica com observações da sua rede de estações meteorológicas Tempest. Horizonte mundial de 10 dias.",
  "forecastModels.everywhereElse": "Em qualquer outro lugar",
  "forecastModels.everywhereElseFoot": "Usado em qualquer estação que os seus modelos preferidos não alcancem.",
  "forecastModels.everywhereElsePick": "Escolha um",
  "forecastModels.fallbackBlend": "Mistura SmartMixin",
  "forecastModels.fallbackBlendSub": "Combina vários modelos, cada um onde é mais forte.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES onde quer que alcance.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "O modelo global da NOAA. O que todas as contas usam hoje.",
  "forecastModels.fallbackResolution": "Resolução mais alta",
  "forecastModels.fallbackResolutionSub": "A malha mais fina em cada estação, mas o GDPS fica atrás do ECMWF e do GFS.",
  "forecastModels.forecastChipLabelWithRun": "{model}, execução {run}",
  "forecastModels.forecastChipRunHint": "Mantenha premido para mostrar ou ocultar a execução mais recente",
  "forecastModels.forecastComparisonDescription": "Compare facilmente dados de diferentes modelos meteorológicos disponíveis",
  "forecastModels.forecastFollowingPreferences": "A seguir as suas preferências",
  "forecastModels.forecastLoadError": "Não foi possível carregar a previsão",
  "forecastModels.forecastModel": "Modelo de previsão",
  "forecastModels.forecastModelAbout": "Sobre {model}",
  "forecastModels.forecastModelComparison": "Comparação de modelos meteorológicos",
  "forecastModels.forecastModelCoverage": "Cobertura",
  "forecastModels.forecastModelDescription": "Descrição",
  "forecastModels.forecastModels": "Modelos de previsão",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Este modelo cobre todo o planeta.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Este modelo cobre apenas uma região específica.",
  "forecastModels.forecastModelSpecifications": "Especificações",
  "forecastModels.forecastNoPinLocation": "Nenhum modelo preferido alcança esta localização — «em qualquer outro lugar» decide.",
  "forecastModels.forecastNoPinStation": "Nenhum modelo preferido alcança esta estação — «em qualquer outro lugar» decide.",
  "forecastModels.forecastNoPreferredModels": "Ainda sem modelos preferidos definidos.",
  "forecastModels.forecastOverrideElsewhere": "As suas preferências aplicam-se em qualquer outro lugar.",
  "forecastModels.forecastPickForLocation": "Ou escolha um para esta localização",
  "forecastModels.forecastPickForStation": "Ou escolha um para esta estação",
  "forecastModels.forecastPinWinsLocation": "{model} — o seu primeiro modelo preferido que alcança esta localização.",
  "forecastModels.forecastPinWinsStation": "{model} — o seu primeiro modelo preferido que alcança esta estação.",
  "forecastModels.forecastServedNowHere": "Neste momento aqui é {model}",
  "forecastModels.forecastSetForLocation": "Definido para esta localização",
  "forecastModels.forecastSetForStation": "Definido para esta estação",
  "forecastModels.forecastSettingsRowSub": "Modelos preferidos, e o que se aplica em qualquer outro lugar",
  "forecastModels.forecastStopUsingHere": "Deixar de usar aqui",
  "forecastModels.forecastUseForLocation": "Usar {model} para esta localização",
  "forecastModels.forecastUseForStation": "Usar {model} para esta estação",
  "forecastModels.forecastUsePreferred": "Usar os meus modelos preferidos",
  "forecastModels.frequencyHourly": "De hora a hora",
  "forecastModels.horizon": "Horizonte",
  "forecastModels.horizonValue": "até {value} horas",
  "forecastModels.meshSize": "Tamanho da malha",
  "forecastModels.pickerShowAll": "Mostrar o catálogo completo",
  "forecastModels.pickerUnreachable": "{count, plural, one {# modelo adicional não alcança} other {# modelos adicionais não alcançam}} nenhuma das suas estações",
  "forecastModels.pinInUse": "Em uso",
  "forecastModels.pinShadowed": "Nunca usado — um modelo acima cobre todas as suas estações",
  "forecastModels.pinSlots": "{used} de {max} · escolha um modelo",
  "forecastModels.pinSlotsFull": "{max, plural, one {O único lugar está ocupado. Remova o respetivo modelo para adicionar outro.} other {Os # lugares estão ocupados. Remova um para adicionar outro.}}",
  "forecastModels.pinsUncoveredCount": "{used} das suas {count, plural, one {# estação} other {# estações}}: nenhum modelo preferido {used, plural, one {a alcança} other {as alcança}} — «em qualquer outro lugar» decide.",
  "forecastModels.pinsUncoveredNamed": "{stations}: nenhum modelo preferido {count, plural, one {a alcança} other {as alcança}} — «em qualquer outro lugar» decide.",
  "forecastModels.pinUnreachable": "Nunca usado — não alcança nenhuma das suas estações",
  "forecastModels.pinUsedAt": "Usado em {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Usado na sua estação} other {Usado em todas as # estações}}",
  "forecastModels.pinUsedAtSome": "Usado em {used} de {count, plural, one {# estação} other {# estações}}",
  "forecastModels.preferredModels": "Modelos preferidos",
  "forecastModels.preferredModelsAll": "Uma lista, todas as estações",
  "forecastModels.preferredModelsOne": "Uma lista, aplica-se em todo o lado",
  "forecastModels.publisher": "Editor",
  "forecastModels.removePreferredModel": "Remover {model} dos seus modelos preferidos",
  "forecastModels.resetForecastPreference": "Repor",
  "forecastModels.resetForecastPreferenceHint": "Limpa os seus modelos preferidos e volta à predefinição da SmartMixin.",
  "forecastModels.servedNowMany": "Neste momento: GFS {count, plural, one {na sua estação} other {em todas as # estações}}.",
  "forecastModels.servedNowNone": "Neste momento: GFS em todo o lado.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodelo",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Previsão Weatherflow",
  "forecastModels.weatherForecastModels": "Modelos de previsão do tempo",
  "helpCenter.articleCount": "{count, plural, one {# artigo} other {# artigos}}",
  "helpCenter.articleNotFound": "Artigo não encontrado",
  "helpCenter.articleNotFoundDescription": "O artigo que procura não existe.",
  "helpCenter.backToHelpCenter": "Voltar à central de ajuda",
  "helpCenter.browseByCategory": "Navegar por categoria",
  "helpCenter.categoryNotFound": "Categoria não encontrada",
  "helpCenter.categoryNotFoundDescription": "Esta categoria não existe ou não tem artigos.",
  "helpCenter.contactSupport": "Contactar o suporte",
  "helpCenter.feedbackHelpsImprove": "A sua opinião ajuda-nos a melhorar os nossos artigos de ajuda.",
  "helpCenter.feedbackReasonNotAnswer": "Não responde à minha pergunta",
  "helpCenter.feedbackReasonOutdated": "As informações estão desatualizadas",
  "helpCenter.feedbackReasonUnclear": "As instruções não são claras",
  "helpCenter.feedbackWhatWentWrong": "Qual foi o problema?",
  "helpCenter.helpCategoryAccount": "Conta",
  "helpCenter.helpCategoryBilling": "Faturação",
  "helpCenter.helpCategoryForecast": "Previsões",
  "helpCenter.helpCategoryGettingStarted": "Primeiros passos",
  "helpCenter.helpCategoryProviders": "Fornecedores",
  "helpCenter.helpCategoryStations": "Estações",
  "helpCenter.helpCategoryTroubleshooting": "Solução de problemas",
  "helpCenter.helpCenter": "Central de ajuda",
  "helpCenter.landingDescription": "Encontre respostas para perguntas comuns e aprenda a aproveitar ao máximo o SmartMixin.",
  "helpCenter.linkToSection": "Link para esta seção",
  "helpCenter.menuItemDescription": "Perguntas frequentes e guias",
  "helpCenter.minRead": "{minutes} min de leitura",
  "helpCenter.onThisPage": "Nesta página",
  "helpCenter.platformMobileApp": "Aplicação móvel",
  "helpCenter.platformMobileOnly": "Apenas na aplicação móvel",
  "helpCenter.platformWebApp": "Aplicação web",
  "helpCenter.platformWebOnly": "Apenas na aplicação web",
  "helpCenter.popularArticles": "Artigos populares",
  "helpCenter.relatedArticles": "Artigos relacionados",
  "helpCenter.searchArticles": "Pesquisar artigos...",
  "helpCenter.stillNeedHelp": "Ainda precisa de ajuda?",
  "helpCenter.stillNeedHelpDescription": "Se este artigo não respondeu à sua pergunta, terei prazer em ajudá-lo diretamente.",
  "helpCenter.supportEmailSubject": "Ajuda SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Ajuda SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Obrigado pelo seu feedback!",
  "helpCenter.wasArticleHelpful": "Este artigo foi útil?",
  "intro.allowLocation": "Permitir localização",
  "intro.alreadyHaveAccount": "Já tem uma conta?",
  "intro.connectStationDescription": "Escolha o seu serviço. Vai iniciar sessão para o ligar.",
  "intro.connectStationTitle": "Ligue a sua estação",
  "intro.haveWeatherStation": "Tenho uma estação meteorológica",
  "intro.locationDescription": "Ative o acesso à localização para obter previsões precisas adaptadas à sua área exata — nada de previsões genéricas.",
  "intro.locationTitle": "Previsões feitas para si",
  "intro.showWeatherHere": "Mostrar o tempo onde estou",
  "intro.showWeatherInstead": "Agora não, mostrar o tempo",
  "intro.welcomeDescription": "Obtenha previsões hiperlocais fornecidas pelas melhores agências meteorológicas — além de acesso a mais de 40.000 estações meteorológicas em todo o mundo para ver as condições reais, passadas e presentes.",
  "intro.welcomeTitle": "O seu tempo, reinventado",
  "landing.alsoAvailableOn": "Também disponível em:",
  "landing.featureAlertsDescription": "Defina limites personalizados para qualquer medição. Receba uma notificação quando a temperatura descer, começar a chover ou o vento aumentar.",
  "landing.featureAlertsTitle": "Alertas inteligentes",
  "landing.featureAnalyticsDescription": "Gráficos interativos, análise de tendências e estatísticas detalhadas. Explore a fundo os dados de temperatura, humidade, pressão, chuva e vento.",
  "landing.featureAnalyticsTitle": "Análise avançada",
  "landing.featureExportDescription": "Receba todos os seus dados meteorológicos por e-mail numa folha de cálculo Excel, pronta para uma análise mais aprofundada no Excel, no Google Sheets ou nas suas ferramentas favoritas.",
  "landing.featureExportTitle": "Exporte os seus dados",
  "landing.featureForecastDescription": "Aceda a {count, plural, one {#+ modelo de previsão profissional} other {#+ modelos de previsão profissionais}}, incluindo ECMWF, GFS e modelos regionais. Compare-os lado a lado para fazer as suas próprias previsões.",
  "landing.featureForecastTitle": "Compare modelos de previsão",
  "landing.featureHistoryDescription": "Aceda a dados históricos com escala horária, diária e mensal. Exporte-os para Excel para investigação ou arquivos pessoais.",
  "landing.featureHistoryTitle": "Histórico detalhado",
  "landing.featureMultiBrandDescription": "Ligue Netatmo, Davis, Tempest, Ecowitt, Ambient Weather e muito mais. Chega de alternar entre aplicações.",
  "landing.featureMultiBrandTitle": "Todas as marcas, uma só aplicação",
  "landing.featuresSubtitle": "O SmartMixin dá-lhe as ferramentas para analisar, comparar e compreender os seus dados meteorológicos como um profissional.",
  "landing.featuresTitle": "Feito para amantes de dados",
  "landing.finalCtaButton": "Criar conta gratuita",
  "landing.finalCtaSubtitle": "Junte-se a milhares de entusiastas de meteorologia que confiam no SmartMixin.",
  "landing.finalCtaTitle": "Pronto para explorar a fundo os seus dados meteorológicos?",
  "landing.heroCta": "Começar gratuitamente",
  "landing.heroDescription": "Análises aprofundadas, gráficos elegantes e previsões profissionais — todas as suas estações meteorológicas reunidas numa única aplicação poderosa.",
  "landing.heroSecondaryCta": "Explorar o mapa",
  "landing.heroTagline": "Para entusiastas do tempo",
  "landing.heroTitle": "Veja o tempo como nunca o viu",
  "landing.pricingComparisonCaption": "Comparação dos recursos dos planos gratuito e Premium",
  "landing.pricingFeatureAdvancedMetrics": "Métricas avançadas",
  "landing.pricingFeatureAlerts": "Alertas personalizados",
  "landing.pricingFeatureColumn": "Recurso",
  "landing.pricingFeatureExport": "Exportação de dados (Excel)",
  "landing.pricingFeatureForecastComparison": "Comparação de previsões",
  "landing.pricingFeatureForecasts": "Modelos de previsão",
  "landing.pricingFeatureForecastsFreeTier": "1 modelo",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modelo} other {#+ modelos}}",
  "landing.pricingFeatureReports": "Análises e relatórios",
  "landing.pricingFeatureStationComparison": "Comparação de estações",
  "landing.pricingFeatureWidgets": "Widgets do ecrã inicial",
  "landing.pricingFeatureYearOverYear": "Análise ano a ano",
  "landing.pricingFreeCta": "Começar",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mais popular",
  "landing.pricingPremiumCta": "Começar",
  "landing.pricingPremiumDescription": "A partir de 1,99 €/mês — subscreva na web, App Store ou Google Play",
  "landing.pricingSubtitle": "Comece gratuitamente, atualize quando precisar de mais.",
  "landing.pricingTitle": "Preços simples e transparentes",
  "landing.statBrands": "Marcas suportadas",
  "landing.statForecasts": "Modelos de previsão",
  "landing.statStations": "Estações meteorológicas",
  "landing.supportedDevicesNote": "Além de mais de {count, number} estações públicas da rede da Organização Meteorológica Mundial",
  "landing.supportedDevicesSubtitle": "Ligue a sua estação meteorológica em poucos minutos. Suportamos {count, plural, one {# grande marca} other {# grandes marcas}} e a lista continua a crescer.",
  "landing.supportedDevicesTitle": "Funciona com a sua estação",
  "metrics.absolutePressure": "Pressão absoluta",
  "metrics.airDensity": "Densidade do ar",
  "metrics.airGap": "Espaço de ar",
  "metrics.apparentTemperature": "Temperatura aparente",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Med.",
  "metrics.avg_wind": "Vento médio",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. globo negro",
  "metrics.boilerOn": "Em aquecimento",
  "metrics.boilerOnInHours": "Em aquecimento (horas)",
  "metrics.cloudCover": "Nebulosidade",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Condutividade",
  "metrics.dailyPrecipitation": "Precipitação diária",
  "metrics.dailyRain": "Chuva diária",
  "metrics.degreeDayShort": "GD",
  "metrics.depth": "Profundidade",
  "metrics.depthSensors": "Sensores de profundidade",
  "metrics.dewPoint": "Ponto de orvalho",
  "metrics.distance": "Distância",
  "metrics.downTrend": "tendência descendente",
  "metrics.ET": "Evapotranspiração",
  "metrics.etToday": "ET hoje",
  "metrics.feelsLike": "Sensação térmica",
  "metrics.feelsLikeWithFormula": "Sensação térmica ({formula})",
  "metrics.frostPoint": "Ponto de geada",
  "metrics.gust": "Rajada",
  "metrics.gustDirection": "Direção da rajada",
  "metrics.hail": "Granizo",
  "metrics.heatIndex": "Índice de calor",
  "metrics.heatingDegreeDays": "Graus-dia de aquecimento",
  "metrics.heatingPower": "Potência de aquecimento",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Humidade",
  "metrics.lastLightningImpact": "Último raio",
  "metrics.lastMeasure": "Última medição",
  "metrics.leafSensors": "Sensores de folha",
  "metrics.leafWetness": "Molhamento foliar",
  "metrics.lightningDistance": "Distância",
  "metrics.lightningStrikeCount": "Número de raios",
  "metrics.lightningStrikeDistance": "Distância do raio",
  "metrics.max": "Máx.",
  "metrics.max_gust": "Rajada máx.",
  "metrics.maxToday": "Máx. hoje",
  "metrics.min": "Mín.",
  "metrics.noise": "Ruído",
  "metrics.normalizedHeatingCoefficient": "Coeficiente de aquecimento normalizado",
  "metrics.outdoorTemperature": "Temperatura exterior",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2.5",
  "metrics.precipitation": "Precipitações",
  "metrics.pressure": "Pressão atmosférica",
  "metrics.rain": "Chuva",
  "metrics.rainDurationValue": "Duração da chuva: {duration}",
  "metrics.rainRate": "Intensidade de chuva",
  "metrics.relativePressure": "Pressão relativa",
  "metrics.setPoint": "Ponto de ajuste",
  "metrics.snow": "Neve",
  "metrics.snowfall": "Queda de neve",
  "metrics.soilMoisture": "Humidade do solo",
  "metrics.soilSensors": "Sensores de solo",
  "metrics.soilWaterTension": "Tensão da água no solo",
  "metrics.solarEnergy": "Energia solar",
  "metrics.solarRadiation": "Radiação solar",
  "metrics.speed": "Velocidade",
  "metrics.stableTrend": "tendência estável",
  "metrics.sum": "Soma",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Sensores de temperatura/humidade",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "tendência de alta",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibilidade",
  "metrics.weatherCondition": "Condição climática",
  "metrics.wetBulbGlobeTemperature": "Temp. globo bolbo húmido",
  "metrics.wetBulbTemperature": "Temp. bolbo húmido",
  "metrics.wind": "Vento",
  "metrics.windChill": "Arrefecimento pelo vento",
  "metrics.windDirection": "Direção do vento",
  "metrics.windRun": "Percurso do vento",
  "metrics.windRunDescription": "O percurso do vento é a distância total percorrida pelo vento durante um período de tempo",
  "metrics.windSpeed": "Velocidade do vento",
  "navigation.allFavorites": "Ver todas",
  "navigation.breadcrumbs": "Trilha de navegação",
  "navigation.collapseNavigation": "Recolher navegação",
  "navigation.expandNavigation": "Expandir navegação",
  "navigation.main": "Principal",
  "navigation.mapShort": "Mapa",
  "navigation.skipToContent": "Ir para o conteúdo principal",
  "network.cancelError": "O pedido foi cancelado",
  "network.connectionError": "Servidor não disponível",
  "network.networkError": "Rede não disponível",
  "network.serverError": "Algo correu errado…",
  "network.timeoutError": "Tempo limite de conexão",
  "network.tooManyRequests": "Demasiados pedidos. Tente mais tarde.",
  "network.unknownError": "Erro desconhecido",
  "premium.alreadyPremium": "Já tem uma conta premium!",
  "premium.bestValue": "Melhor oferta",
  "premium.billingDetailsAndroid": "Período experimental gratuito: não será cobrado se cancelar pelo menos 24 horas antes do fim do período experimental. Depois disso, a sua subscrição do SmartMixin é renovada automaticamente, a menos que a cancele pelo menos 24 horas antes do fim do período atual; pode cancelá-la a qualquer momento nas definições da sua conta do Google Play. Cada renovação é cobrada ao preço indicado no botão acima. O pagamento é cobrado na sua conta do Google Play quando confirmar a compra e no início de cada período de renovação.",
  "premium.billingDetailsIos": "Período experimental gratuito: não será cobrado se cancelar pelo menos 24 horas antes do fim do período experimental. Depois disso, a sua subscrição do SmartMixin é renovada automaticamente, a menos que a cancele pelo menos 24 horas antes do fim do período atual; pode cancelá-la a qualquer momento nas definições da sua conta da App Store. Cada renovação é cobrada ao preço indicado no botão acima. O pagamento é cobrado na sua conta da App Store quando confirmar a compra e no início de cada período de renovação.",
  "premium.freeBannerBody": "Sem Premium recebe GFS em todo o lado — os seus modelos preferidos e «em qualquer outro lugar» começam a funcionar assim que subscrever.",
  "premium.freeBannerTitle": "As preferências aplicam-se com Premium",
  "premium.freeSubscription": "Subscrição gratuita",
  "premium.freeTrialForPeriod": "Período experimental gratuito de {period, plural, one {# dia} other {# dias}}",
  "premium.getUnlimitedAccess": "Acesso ilimitado a:",
  "premium.manageMySubscription": "Gerir a minha subscrição",
  "premium.notPurchasedYet": "Não foi encontrada nenhuma compra do SmartMixin Premium nesta conta da loja.",
  "premium.orChooseMonthly": "Ou escolha mensal:",
  "premium.plansRetry": "Tentar novamente",
  "premium.plansUnavailable": "Não foi possível carregar os planos de subscrição. Verifique a ligação à internet e tente novamente.",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Ativo",
  "premium.premiumAnnualTrialInfo": "Comece com um período experimental gratuito de {days, plural, one {# dia} other {# dias}}",
  "premium.premiumCurrentPlan": "Plano atual",
  "premium.premiumDownloadApp": "Transfira a aplicação para subscrever:",
  "premium.premiumEndsOn": "Expira a {date}",
  "premium.premiumFeatureAlerts": "Alertas meteorológicos",
  "premium.premiumFeatureAnalysis": "Análise meteorológica avançada",
  "premium.premiumFeatureCharts": "Comparações de gráficos",
  "premium.premiumFeatureExport": "Exportação de dados",
  "premium.premiumFeatureForecast": "Modelos de previsão regional",
  "premium.premiumFeatureNotification": "Widget da barra de status",
  "premium.premiumFeatureTitle": "Recurso Premium",
  "premium.premiumFeatureWidgets": "Widgets do ecrã inicial",
  "premium.premiumFreePlan": "Gratuito",
  "premium.premiumInactive": "Não subscrito",
  "premium.premiumManageStoreSubscription": "Subscreveu através da loja {store}. Faça a gestão ou cancele a subscrição lá.",
  "premium.premiumManageWebSubscription": "Faça a gestão da sua subscrição, atualize o método de pagamento ou cancele.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Renova a {date}",
  "premium.premiumSubscribeAnnual": "Anual — 9,99 €/ano",
  "premium.premiumSubscribedOn": "Subscrito em {platform}",
  "premium.premiumSubscribedOnWeb": "Subscrito na web",
  "premium.premiumSubscribeMonthly": "Mensal — 1,99 €/mês",
  "premium.premiumSubscribeOnWeb": "Subscreva agora para desbloquear todas as funcionalidades premium.",
  "premium.premiumSubscriptionSuccess": "A sua subscrição foi ativada! Aproveite todas as funcionalidades premium.",
  "premium.premiumSubscriptionSuccessTitle": "Bem-vindo ao Premium!",
  "premium.premiumWebappNotice": "De momento, não é possível subscrever na web.",
  "premium.pricePerMonth": "{price}/mês",
  "premium.pricePerYear": "{price}/ano",
  "premium.purchasedNetatmoPro": "Comprou anteriormente o Netatmo Pro ({date}). Este dá-lhe acesso a uma parte dos recursos premium. Subscreva uma das ofertas abaixo se quiser ter acesso a todos os recursos premium.",
  "premium.purchaseFailed": "Não foi possível concluir a compra. Tente novamente.",
  "premium.restoreFailed": "Não foi possível restaurar as suas compras. Tente novamente.",
  "premium.restorePurchase": "Restaurar compra",
  "premium.savingsPercent": "Poupe {percent}%",
  "premium.seePremium": "Ver Premium",
  "premium.startFreeTrial": "Iniciar teste gratuito",
  "premium.storeUnavailable": "A loja não está disponível neste momento. Tente novamente mais tarde.",
  "premium.subscribeNow": "Subscrever agora — sem período experimental",
  "premium.switchToPremium": "Mudar para SmartMixin Premium",
  "premium.thenPrice": "depois {price}",
  "providerHints.ambientWeatherApiKey": "Criada nas definições da sua conta ambientweather.net.",
  "providerHints.davisApiSecret": "Mostrado apenas uma vez ao criar a chave API V2 — guarde-o em segurança.",
  "providerHints.davisV2ApiKey": "Da página de chaves API V2 em weatherlink.com.",
  "providerHints.ecowittApi": "Da página API da sua conta Ecowitt.",
  "providerHints.ecowittApp": "A chave de aplicação, também da sua conta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Use o e-mail e a palavra-passe da sua conta My AcuRite — não o acesso SmartMixin.",
  "providerHints.myAcuriteEmail": "O e-mail da sua conta My AcuRite — não o seu acesso SmartMixin.",
  "providerHints.myAcuritePassword": "A palavra-passe da sua conta My AcuRite.",
  "providerHints.weatherflowToken": "Token de uso pessoal de tempestwx.com → definições → autorizações de dados.",
  "providerHints.wundergroundEditKey": "Usar outra chave",
  "providerHints.wundergroundKey": "Uma sequência longa da página de chaves API da sua conta Weather Underground — não a sua palavra-passe do wunderground.com.",
  "providerHints.wundergroundKeyExample": "ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Chave API verificada",
  "providerHints.wundergroundNoStationsNearby": "Não foram encontradas estações perto desta localização. Tente introduzir um ID de estação diretamente.",
  "providerHints.wundergroundStationIdExample": "ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obtenha a sua chave API Ambient Weather.",
  "providerIntro.davisStep2": "Obtenha a sua chave API V2 e segredo API Davis.",
  "providerIntro.ecowittStep2": "Obtenha a sua chave API e chave de aplicação Ecowitt.",
  "providerIntro.getStarted": "Começar",
  "providerIntro.myAcuriteStep2": "Use o e-mail e palavra-passe da sua conta My AcuRite existente.",
  "providerIntro.netatmoEnergyStep2": "Inicie sessão no Netatmo quando solicitado — não é necessária chave API.",
  "providerIntro.netatmoWeatherStep2": "Inicie sessão no Netatmo quando solicitado — não é necessária chave API.",
  "providerIntro.signupBanner": "Quase — crie a sua conta gratuita SmartMixin para ligar {provider}.",
  "providerIntro.step1": "Inicie sessão na sua conta SmartMixin (NÃO o login {provider}).",
  "providerIntro.step3EmailPassword": "Introduza-os aqui.",
  "providerIntro.step3KeyOrToken": "Cole aqui.",
  "providerIntro.step3OAuth": "Autorize SmartMixin na janela que aparece.",
  "providerIntro.step3Wunderground": "Cole a sua chave API e depois selecione uma estação próxima ou insira qualquer ID de estação.",
  "providerIntro.stepOfTotal": "Passo {step} de {total}",
  "providerIntro.title": "Ligar {provider}",
  "providerIntro.weatherflowStep2": "Obtenha o seu token Tempest de uso pessoal.",
  "providerIntro.wundergroundBrowsePublic": "Não tem estação? Explore as públicas",
  "providerIntro.wundergroundFindNearby": "Encontrar estações próximas",
  "providerIntro.wundergroundOrEnterId": "Ou introduzir um ID de estação",
  "providerIntro.wundergroundStep2": "Obtenha a sua chave API Weather Underground. Depois poderá ligar qualquer estação — a sua ou uma pública.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Análise",
  "reports.annualCumulativeRainfallComparison": "Comparação dos totais anuais de precipitação",
  "reports.annualHeatingDurationComparison": "Comparação da duração de aquecimento anual",
  "reports.annualHeatingEfficiency": "Eficiência térmica anual",
  "reports.annualIndoorComparison": "Comparação interior anual",
  "reports.annualOutdoorComparison": "Comparação exterior anual",
  "reports.annualOutdoorReport": "Reporte exterior anual",
  "reports.annualReport": "Reporte anual",
  "reports.annualSolarReport": "Relatório solar anual",
  "reports.annualWaterBalance": "Balanço hídrico anual",
  "reports.annualWaterBalanceCarryOver": "Transferir de {year} ({value})",
  "reports.annualWaterBalanceDescription": "Um balanço hídrico (versão simplificada, apenas a chuva e a evapotranspiração são usadas) permite gerir o recurso hídrico",
  "reports.avgHumidity": "Humidade média",
  "reports.avgMaxTemperature": "T°max média",
  "reports.avgMetric": "Média – {metric}",
  "reports.avgMinTemperature": "T°min média",
  "reports.avgPressure": "Pressão atmosférica média",
  "reports.avgTemperature": "Temperatura média",
  "reports.chartsAndTable": "Gráficos e tabela",
  "reports.climateNormalPeriodOfRecord": "Período de observação ({years, plural, one {# ano} other {# anos}})",
  "reports.climateNormals": "Normais climatológicas",
  "reports.climateNormalStandardLabel": "Normal padrão ({period})",
  "reports.climateTrendPerDecade": "Tendência da temperatura: {value} por década ao longo de {years, plural, one {# ano} other {# anos}}",
  "reports.coldestMonthRanking": "{month} mais frio já registado",
  "reports.comfortable": "Confortável (45% {lessThan} Humidade ≤ 60%)",
  "reports.coverageAllDays": "{total, plural, one {# dia} other {Todos os # dias}}",
  "reports.coverageMetricsCount": "{metrics}: {count} de {total, plural, one {# dia} other {# dias}}",
  "reports.coverageMetricsEveryDay": "{metrics}: todos os dias",
  "reports.coverageMonthToDate": "Desde o início do mês",
  "reports.coverageNoReadings": "Sem leituras: {dates}",
  "reports.coverageReadingsCount": "Leituras em {count} de {total, plural, one {# dia} other {# dias}}",
  "reports.coverageTodayUntil": "Hoje até às {time}",
  "reports.coverageYearToDate": "Desde o início do ano",
  "reports.cumulativeRainfall": "Precipitação acumulada",
  "reports.cumulativeRainfallDescription": "Acompanhe a precipitação total acumulada durante o período selecionado.",
  "reports.dailyMaxRainfall": "Precipitação máxima diária",
  "reports.dataExport": "Exportar dados",
  "reports.dataExportXlsxFormatDescription": "Exporte todos os dados da sua estação em formato Excel (*.xlsx). Após clicar no botão, irá receber um email com os seus dados processados após alguns minutos.",
  "reports.daysOfData": "{days, plural, one {# dia} other {# dias}} de dados",
  "reports.daysWithFrost": "Dias com geada",
  "reports.daysWithHeavyRain": "Dias de chuva forte (≥ {threshold})",
  "reports.daysWithoutThaw": "Dias sem degelo",
  "reports.daysWithStrongFrost": "Dias com geada forte",
  "reports.emailSent": "Um email foi enviado para a sua caixa de correio",
  "reports.frostDays": "Dias de geada",
  "reports.grasslandTemperatureSum": "Soma da temperatura da pastagem",
  "reports.grasslandTemperatureSumDescription": "Se a soma de {threshold} é excedida na primavera, foi alcançada a recuperação sustentável da vegetação (funciona na Europa)",
  "reports.grasslandThresholdLabel": "Início da vegetação: {threshold}",
  "reports.growingDegreeDays": "Graus-dia de crescimento",
  "reports.highPressure": "Anticiclone (Pressão Média ≥ {threshold})",
  "reports.historyImportInProgress": "O histórico mais antigo da sua estação ainda está a ser importado. Nos próximos dias vão aparecer mais anos.",
  "reports.iceDays": "Dias de gelo",
  "reports.indoorReport": "Reporte interior",
  "reports.keyFacts": "Factos chave",
  "reports.longestDrySpell": "Maior período seco",
  "reports.longestRunOfRainyDays": "Número de dias chuvosos consecutivos",
  "reports.longestRunWithoutRun": "Número de dias consecutivos sem chuva",
  "reports.longestWetSpell": "Maior período chuvoso",
  "reports.lowPressure": "Baixa Pressão (Pressão Média {lessThan} {threshold})",
  "reports.maxHumidity": "Humidade máxima",
  "reports.maxMetric": "Máximo – {metric}",
  "reports.maxPressure": "Pressão atmosférica máxima",
  "reports.maxTemperature": "Temperatura máxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitude Máxima (/24H)",
  "reports.minHumidity": "Humidade mínima",
  "reports.minMetric": "Mínimo – {metric}",
  "reports.minPressure": "Pressão atmosférica mínima",
  "reports.minTemperature": "Temperatura mínima",
  "reports.minTempMagnitude24h": "Amplitude Mínima (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Mais # dia} other {Mais # dias}} este mês",
  "reports.monthlyAverageCountdownDetail": "Então aparecerão a média do mês e a sua classificação.",
  "reports.monthlyAverageRule": "As médias mensais e as classificações aparecem quando um mês de calendário tem {days, plural, one {# dia registado} other {# dias registados}}.",
  "reports.monthlyHeatingEfficiency": "Eficiência térmica mensal",
  "reports.monthlyOutdoorReport": "Reporte exterior mensal",
  "reports.monthlyReport": "Reporte mensal",
  "reports.monthlySolarReport": "Relatório solar mensal",
  "reports.monthlyWindReport": "Reporte de vento mensal",
  "reports.monthsOfData": "{months, plural, one {# mês} other {# meses}} de dados",
  "reports.noReadings": "Sem leituras",
  "reports.numberOfDays": "Número de Dias",
  "reports.onThisDayChartRule": "O gráfico ano a ano aparece quando houver {count, plural, one {# ano registado} other {# anos registados}} de {date}.",
  "reports.onThisDayChartSummary": "{years, plural, one {# ano} other {# anos}} com temperatura, de {first} a {last}. Recorde de calor {high} em {highYears}, recorde de frio {low} em {lowYear}. Dia normal de {min} a {max}.",
  "reports.onThisDayChartSummaryNoNormal": "{years, plural, one {# ano} other {# anos}} com temperatura, de {first} a {last}. Recorde de calor {high} em {highYears}, recorde de frio {low} em {lowYear}.",
  "reports.onThisDayCoverage": "{years, plural, one {# ano desde {firstYear}} other {# anos desde {firstYear}}}",
  "reports.onThisDayDataSince": "Esta estação tem dados desde {date}.",
  "reports.onThisDayEveryYear": "Todos os {date} registados",
  "reports.onThisDayGapNoData": "sem dados",
  "reports.onThisDayHighOnlySummary": "{year}: máxima {max}, chuva {rain}",
  "reports.onThisDayInHistory": "Neste dia na história",
  "reports.onThisDayLeaveOk": "Pode sair deste ecrã; o carregamento continua.",
  "reports.onThisDayLoadFailed": "Não foi possível carregar {date}. Verifique a ligação e tente novamente.",
  "reports.onThisDayLowOnlySummary": "{year}: mínima {min}, chuva {rain}",
  "reports.onThisDayNoDataRun": "{start}–{end} · sem dados ({count, plural, one {# ano} other {# anos}})",
  "reports.onThisDayNormal": "Dia normal: de {min} a {max}",
  "reports.onThisDayNoYears": "Ainda não há nenhum {date} completo registado",
  "reports.onThisDayNoYearsDetail": "Esta página preenche-se a partir do primeiro {date} que a estação registar por completo.",
  "reports.onThisDayNoYearSelected": "Nenhum ano selecionado",
  "reports.onThisDayOneReading": "1 leitura",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 leitura, chuva {rain}",
  "reports.onThisDayOpenRecords": "Abrir Recordes e clima",
  "reports.onThisDayPickHint": "Altera o dia mostrado",
  "reports.onThisDayPickTitle": "Escolher um dia",
  "reports.onThisDayRain": "Chuva a {date}",
  "reports.onThisDayRainNotMeasured": "não medida",
  "reports.onThisDayRainOnlySummary": "{year}: chuva {rain}",
  "reports.onThisDayRainSince": "chuva desde {year}",
  "reports.onThisDayRainSummary": "Chuva a {date}. Dia mais chuvoso {value} em {years}.",
  "reports.onThisDayRetry": "Tentar novamente",
  "reports.onThisDaySingleReading": "{count, plural, one {# ano tem} other {# anos têm}} uma única leitura nesse dia e não {count, plural, one {é desenhado} other {são desenhados}}.",
  "reports.onThisDaySlowLoad": "A ler {years, plural, one {# ano} other {# anos}} de {date}. A primeira consulta de uma data pode demorar até 20 segundos.",
  "reports.onThisDaySlowLoadGeneric": "A ler o histórico desta estação de {date}. A primeira consulta de uma data pode demorar até 20 segundos.",
  "reports.onThisDayTied": "empatado com {years}",
  "reports.onThisDayTiedMore": "empatado com {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: mínima {min}, máxima {max}, chuva {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Reporte exterior",
  "reports.overviewSection": "Visão geral",
  "reports.rainfall": "Precipitação",
  "reports.rainyDays": "Dias chuvosos",
  "reports.recordCalendarDay": "Dia civil (da meia-noite à meia-noite)",
  "reports.recordClimatologicalDay": "Dia climatológico (06–06 UTC)",
  "reports.recordClimDayBody": "O dia mais chuvoso é calculado de duas formas. O dia civil vai da meia-noite à meia-noite na hora da estação. O dia climatológico vai das 06:00 às 06:00 UTC, como o contam os serviços meteorológicos. Os dois podem dividir a mesma tempestade de forma diferente, por isso os seus totais podem diferir, e por vezes também as datas.",
  "reports.recordDailyRain": "Dia mais chuvoso",
  "reports.recordFromHourlyReadings": "Das leituras horárias",
  "reports.recordHigh": "Recorde de calor",
  "reports.recordLow": "Recorde de frio",
  "reports.recordOfficialBody": "O serviço meteorológico publica uma máxima e uma mínima diárias para esta estação, lidas em termómetros de máxima e de mínima. Captam picos breves que as leituras horárias não registam, por isso substituem os valores calculados a partir das leituras horárias.",
  "reports.recordOfficialValue": "Valor oficial",
  "reports.recordsAndClimatology": "Recordes e clima",
  "reports.recordSheetTitle": "Sobre estes recordes",
  "reports.recordsSince": "Recordes desde {date}",
  "reports.recordWindGust": "Rajada de vento mais forte",
  "reports.relativelyWet": "Relativamente húmido (60% {lessThan} Humidade ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# relatório} other {# relatórios}}",
  "reports.sendEmail": "Enviar email",
  "reports.summerDays": "Dias de verão",
  "reports.tableScrollRegion": "{title}, desloca-se na horizontal",
  "reports.tooDry": "Muito seco (Humidade ≤ 45%)",
  "reports.tooWet": "Muito húmido (Humidade {greaterThan} 80%)",
  "reports.tropicalNights": "Noites tropicais",
  "reports.unlockPremiumSubtitle": "Incluído no SmartMixin Premium",
  "reports.unlockPremiumTitle": "Desbloqueie {count, plural, one {# recurso premium} other {# recursos premium}}",
  "reports.warmestMonthRanking": "{month} mais quente já registado",
  "reports.waterBalance": "Balanço hídrico",
  "reports.yearsOfData": "{years, plural, one {# ano} other {# anos}} de dados",
  "reports.yearToDateTemperatureComparison": "Comparação de temperatura acumulada no ano",
  "sensors.bgtSensors": "Globo negro e WBGT",
  "sensors.cameraFeed": "Câmara",
  "sensors.compareHumidity": "Comparar humidade",
  "sensors.compareMoisture": "Comparar humidade do solo",
  "sensors.comparePm25": "Comparar PM2.5",
  "sensors.compareTemperatures": "Comparar temperaturas",
  "sensors.compareWaterTension": "Comparar tensão da água no solo",
  "sensors.depthByChannel": "Profundidade por canal",
  "sensors.heatStressExtreme": "Stress térmico extremo",
  "sensors.heatStressModerate": "Stress térmico moderado",
  "sensors.heatStressNone": "Sem stress térmico",
  "sensors.heatStressStrong": "Stress térmico forte",
  "sensors.heatStressVeryStrong": "Stress térmico muito forte",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Níveis de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura e humidade",
  "sensors.leafWetnessByChannel": "Humidade das folhas por canal",
  "sensors.lightningSensor": "Relâmpago",
  "sensors.moistureByChannel": "Humidade do solo por canal",
  "sensors.noDataAvailable": "Sem dados disponíveis",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 por canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Selecionar canal",
  "sensors.sensorDetailDescription": "Veja dados históricos e tendências dos canais do sensor.",
  "sensors.sensorHistory": "Histórico do sensor",
  "sensors.soilConductivityByChannel": "Condutividade por canal",
  "sensors.soilTemperatureByChannel": "Temperatura do solo por canal",
  "sensors.strikesToday": "Raios hoje",
  "sensors.temperatureByChannel": "Temperatura por canal",
  "sensors.viewChart": "Ver gráfico",
  "sensors.waterTensionByChannel": "Tensão da água no solo por canal",
  "settings.appearance": "Aparência",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "árabe",
  "settings.bulgarian": "búlgaro",
  "settings.catalan": "catalão",
  "settings.chartGestures": "Gestos nos gráficos",
  "settings.chartGesturesDescription": "Deslizar nos gráficos muda o período de tempo, pinçar nos gráficos muda a escala de tempo",
  "settings.choiceCount": "{count, plural, one {# disponível} other {# disponíveis}}",
  "settings.contactUs": "Contacte-nos",
  "settings.contactUsDescription": "Obtenha ajuda ou envie feedback",
  "settings.croatian": "croata",
  "settings.czech": "checo",
  "settings.dailyDetailByPeriods": "Detalhe diário por períodos",
  "settings.dailyDetailByPeriodsDescription": "Agrupa as 24 horas em noite, manhã, tarde e anoitecer — a mesma divisão que o resumo do dia utiliza.",
  "settings.danish": "dinamarquês",
  "settings.dark": "Tema escuro",
  "settings.dataDisplay": "Exibição de dados",
  "settings.dateAndTime": "Data e hora",
  "settings.donateButton": "Fazer uma doação",
  "settings.donateDescription": "O SmartMixin é desenvolvido por uma pequena equipa. Se o considera útil, pode apoiar o seu desenvolvimento com uma doação única de qualquer valor. É um presente — não altera o seu plano nem desbloqueia nenhum recurso.",
  "settings.donateSuccessBody": "A sua doação ajuda a manter o SmartMixin a funcionar e a melhorá-lo. Agradecemos de verdade.",
  "settings.donateSuccessTitle": "Obrigado pelo seu apoio!",
  "settings.donateTitle": "Apoie o SmartMixin",
  "settings.dragToReorder": "Arraste para reordenar",
  "settings.dutch": "holandês",
  "settings.english": "inglês",
  "settings.french": "francês",
  "settings.german": "alemão",
  "settings.gestures": "Gestos",
  "settings.greek": "grego",
  "settings.hungarian": "húngaro",
  "settings.italian": "italiano",
  "settings.japanese": "japonês",
  "settings.korean": "coreano",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferido",
  "settings.light": "Tema claro",
  "settings.mapTheme": "Tema do mapa",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Escuro",
  "settings.mapThemeDescription": "Com Auto, o mapa acompanha o tema da aplicação.",
  "settings.mapThemeLight": "Claro",
  "settings.measurementUnits": "Unidades de medida",
  "settings.netatmoDashboard": "Painel Netatmo",
  "settings.netatmoLayoutCards": "Lista de cartões",
  "settings.netatmoLayoutCardsDescription": "Um cartão por módulo, tudo num único deslocamento",
  "settings.netatmoLayoutClassic": "Clássico",
  "settings.netatmoLayoutClassicDescription": "Dois cartões, deslize entre módulos",
  "settings.netatmoNewLayoutNotice": "Novo esquema do painel: um cartão por módulo.",
  "settings.netatmoSwitchBackToClassic": "Voltar ao clássico",
  "settings.netatmoSwitchToLayout": "Mudar para {layout}",
  "settings.norwegian": "norueguês",
  "settings.notificationsSection": "Notificações",
  "settings.ongoingNotificationEnabled": "Ativar notificação permanente",
  "settings.ongoingNotificationMetrics": "Métricas exibidas",
  "settings.ongoingNotificationPermissionRequired": "É necessária permissão de notificação",
  "settings.ongoingNotificationPreviewHint": "Pré-visualização: ative o widget para mostrá-lo",
  "settings.ongoingNotificationStatusBar": "Barra de status",
  "settings.polish": "polaco",
  "settings.portuguese": "português",
  "settings.preferencesSection": "Preferências",
  "settings.privacyPolicy": "Política de privacidade",
  "settings.russian": "russo",
  "settings.serbian": "sérvio",
  "settings.settings": "Definições",
  "settings.settingsPageTitle": "Definições - {page}",
  "settings.slovak": "eslovaco",
  "settings.smallDecimals": "Decimais pequenos",
  "settings.smallDecimalsDescription": "Exibir dígitos decimais num tamanho menor",
  "settings.spanish": "espanhol",
  "settings.statusBarWidget": "Widget da barra de status",
  "settings.statusBarWidgetDescription": "Dados meteorológicos sempre visíveis",
  "settings.subscriptionSection": "Subscrição",
  "settings.supportSection": "Suporte",
  "settings.swedish": "sueco",
  "settings.systemTheme": "Tema do sistema",
  "settings.termsOfService": "Condições de utilização",
  "settings.themeDarkShort": "Escuro",
  "settings.themeLightShort": "Claro",
  "settings.themeSystemShort": "Sistema",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucraniano",
  "settings.units": "Unidades",
  "settings.unitsDescription": "Unidades de medida exibidas na aplicação",
  "settings.update": "Atualizar",
  "settings.windDirectionConvention": "Seta de direção do vento",
  "settings.windDirectionConventionDescription": "Escolha como as setas de direção do vento são exibidas",
  "settings.windDirectionMeteorological": "Direção de origem",
  "settings.windDirectionMeteorologicalDescription": "A seta indica de onde o vento vem (convenção meteorológica)",
  "settings.windDirectionOceanographic": "Direção do fluxo",
  "settings.windDirectionOceanographicDescription": "A seta indica para onde o vento sopra (convenção oceanográfica)",
  "stations.addAStation": "Adicionar estação",
  "stations.addToFavorites": "Adicionar aos favoritos",
  "stations.addYourOwnStation": "Adicione a sua estação",
  "stations.allowPreciseLocation": "Permitir localização precisa",
  "stations.approximateLocationUnavailable": "A localização aproximada não está disponível. Toque para permitir a localização precisa.",
  "stations.backToCurrentLocation": "Voltar à localização atual",
  "stations.backToPlace": "Voltar: {place}",
  "stations.browserLocationUnavailable": "Não foi possível encontrar a sua localização. Verifique se o seu navegador permite que este site a utilize e tente novamente.",
  "stations.calculatedFor": "Calculado para as {time} · {model}",
  "stations.clearRecentLocations": "Limpar tudo",
  "stations.currentLocation": "Localização atual",
  "stations.customizedStationName": "Nome de estação personalizado",
  "stations.editMyWeather": "Editar O meu tempo",
  "stations.favoriteLocations": "Favoritos",
  "stations.filterStations": "Filtrar estações",
  "stations.filterStationSourceDescription": "Selecione os fornecedores de estação que deseja exibir no mapa",
  "stations.findingYourLocation": "A obter a sua localização…",
  "stations.hiddenFromMyWeather": "Ocultado: {name}",
  "stations.hiddenStations": "Estações ocultas",
  "stations.hiddenStationsDescription": "Pode voltar a mostrar uma estação tocando no ícone do olho ao lado dela.",
  "stations.hideStationNamed": "Ocultar {station}",
  "stations.lastSeen": "visto {time}",
  "stations.loadingStation": "A carregar a estação…",
  "stations.location": "Localização",
  "stations.locationAddedToFavorites": "Localização adicionada aos favoritos",
  "stations.locationNotGranted": "A permissão de localização não é concedida. Permita o acesso à sua localização nas configurações do dispositivo.",
  "stations.locationRemovedFromFavorites": "Localização removida dos favoritos",
  "stations.locations": "Localizações",
  "stations.locationUnavailable": "Não foi possível obter a sua localização. Verifique as configurações do dispositivo.",
  "stations.maxFavoriteLocationsReached": "Só pode ter até 5 locais favoritos. Remova um para adicionar outro.",
  "stations.modifyFavoriteStations": "Modificar estações favoritas",
  "stations.modifyFavoriteStationsDescription": "Pode reordenar as suas estações favoritas arrastando-as. Também pode removê-las da lista.",
  "stations.moreStationsFailed": "Não foi possível carregar mais estações",
  "stations.myLocation": "Minha localização",
  "stations.myStations": "As minhas estações",
  "stations.myWeather": "O meu tempo",
  "stations.myWeatherIntroBody": "As suas estações continuam no topo. A pesquisa encontra agora localidades e estações.",
  "stations.myWeatherIntroOk": "OK",
  "stations.myWeatherIntroTitle": "Estações e locais numa só lista",
  "stations.myWeatherItemActions": "Ações para {name}",
  "stations.nearbyWeatherStations": "Estações meteorológicas próximas",
  "stations.noLocationsFound": "Nenhum local encontrado",
  "stations.noLocationTitle": "Onde quer ver o tempo?",
  "stations.noLongerReported": "Já não consta",
  "stations.noLongerReportedBy": "Já não consta em {provider} desde {date}",
  "stations.noPlaceFound": "Nenhum local encontrado",
  "stations.noSearchResults": "Nenhum artigo corresponde à sua pesquisa",
  "stations.noStationNamed": "Nenhuma estação com o nome «{query}»",
  "stations.noStationsFound": "Nenhuma estação encontrada",
  "stations.noWeatherStationYet": "Ainda não tem uma estação meteorológica.",
  "stations.places": "Locais",
  "stations.placeSearchFailed": "Não foi possível carregar os locais",
  "stations.recentLocations": "Recentes",
  "stations.removedFromMyWeather": "Removido: {name}",
  "stations.removeFromFavorites": "Remover dos favoritos",
  "stations.removeFromMyWeatherFailed": "Não foi possível remover {name}",
  "stations.removeStationNamed": "Remover {station} dos favoritos",
  "stations.reorderStationNamed": "Mover {station}",
  "stations.searchForLocation": "Procurar uma localização",
  "stations.searchForWeatherStation": "Procurar uma estação meteorológica",
  "stations.searchPlaceOrStation": "Procurar um local ou uma estação",
  "stations.searchResultsFound": "{count, plural, one {# resultado encontrado} other {# resultados encontrados}}",
  "stations.searchSummary": "{places, plural, one {# local} other {# locais}}, {stations, plural, one {# estação} other {# estações}}",
  "stations.searchTryAgain": "Tentar novamente",
  "stations.selectStationForComparison": "Selecione a estação para comparação",
  "stations.showAllStations": "Mostrar todas ({count})",
  "stations.shownInMyWeather": "Mostrado novamente: {name}",
  "stations.stationAddedToFavorites": "Estação adicionada aos favoritos",
  "stations.stationInformation": "Informação da estação",
  "stations.stationName": "Nome da estação",
  "stations.stationObservationsDescription": "Exibir as últimas observações das estações meteorológicas",
  "stations.stationRemovedFromFavorites": "Estação removida dos favoritos",
  "stations.stationSearchFailed": "Não foi possível carregar as estações",
  "stations.stationsLoading": "A carregar as estações meteorológicas",
  "stations.stationType": "Tipo de estação",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Desatualizado",
  "stations.undoRemove": "Anular",
  "stations.unhideStationNamed": "Voltar a mostrar {station}",
  "stations.useMyLocation": "Usar a minha localização",
  "stations.weatherStation": "Estação meteorológica",
  "stations.weatherStations": "Estações meteorológicas",
  "stations.welcomeConnectService": "Possui uma estação meteorológica? Conecte o seu serviço",
  "stations.welcomeSubtitle": "O seu tempo, tudo num só lugar",
  "thermostat.away": "Ausente",
  "thermostat.boilerOn": "Em aquecimento",
  "thermostat.hg": "Proteção contra geada",
  "thermostat.homeInformation": "Informação sobre a casa",
  "thermostat.homeName": "Nome da casa",
  "thermostat.manualBoost": "Impulso manual",
  "thermostat.manualSetpointUntil": "Ponto de ajuste manual até",
  "thermostat.noThermostatYet": "Ainda não tem um termóstato.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Divisão",
  "thermostat.roomAnticipating": "Aquecimento antecipado para a próxima temperatura programada",
  "thermostat.roomOpenWindow": "Janela aberta detetada, aquecimento em pausa",
  "thermostat.rooms": "Divisões",
  "thermostat.smartThermostat": "Termóstato inteligente",
  "thermostat.smartValve": "Válvula inteligente",
  "thermostat.whenBackHome": "Quando irá voltar a casa?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Polegadas",
  "units.inchOfMercury": "Polegadas de mercúrio",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Quilómetros por hora",
  "units.knot": "Nós",
  "units.meterPerSecond": "Metros por segundo",
  "units.milePerHour": "Milhas por hora",
  "units.millibar": "Milibares",
  "units.millimeter": "Milímetros",
  "units.millimeterOfMercury": "Milímetros de mercúrio",
  "weatherConditions.blizzard": "Nevasca",
  "weatherConditions.blowingDust": "Poeira levantada pelo vento",
  "weatherConditions.blowingSnow": "Neve levantada pelo vento",
  "weatherConditions.breezy": "Brisa",
  "weatherConditions.clear": "Céu limpo",
  "weatherConditions.cloudy": "Nublado",
  "weatherConditions.drizzle": "Chuvisco",
  "weatherConditions.flurries": "Neve fraca",
  "weatherConditions.foggy": "Nevoeiro",
  "weatherConditions.freezingDrizzle": "Chuvisco congelante",
  "weatherConditions.freezingRain": "Chuva congelante",
  "weatherConditions.frigid": "Frio intenso",
  "weatherConditions.hail": "Granizo",
  "weatherConditions.haze": "Névoa seca",
  "weatherConditions.heavyRain": "Chuva forte",
  "weatherConditions.heavySnow": "Neve forte",
  "weatherConditions.hot": "Calor",
  "weatherConditions.hurricane": "Furacão",
  "weatherConditions.isolatedThunderstorms": "Trovoadas isoladas",
  "weatherConditions.mixedRainAndHail": "Chuva e granizo",
  "weatherConditions.mostlyClear": "Maioritariamente limpo",
  "weatherConditions.mostlyCloudy": "Muito nublado",
  "weatherConditions.mostlySunny": "Maioritariamente solarengo",
  "weatherConditions.notAvailable": "Condições meteorológicas indisponíveis",
  "weatherConditions.partlyCloudy": "Parcialmente nublado",
  "weatherConditions.rain": "Chuva",
  "weatherConditions.rainSleet": "Chuva e gelo granulado",
  "weatherConditions.rainSnow": "Chuva e neve",
  "weatherConditions.scatteredShowers": "Aguaceiros dispersos",
  "weatherConditions.scatteredSnowShowers": "Aguaceiros de neve dispersos",
  "weatherConditions.scatteredThunderstorms": "Trovoadas dispersas",
  "weatherConditions.showers": "Aguaceiros",
  "weatherConditions.sleet": "Gelo granulado",
  "weatherConditions.smoke": "Fumo",
  "weatherConditions.snow": "Neve",
  "weatherConditions.snowShowers": "Aguaceiros de neve",
  "weatherConditions.strongStorms": "Trovoadas fortes",
  "weatherConditions.sunny": "Solarengo",
  "weatherConditions.thunderstorms": "Trovoadas",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tempestade tropical",
  "weatherConditions.windy": "Vento forte",
  "weatherConditions.wintryMix": "Precipitação invernal mista",
  "weatherMap.clusterMarkerName": "{metric} {value}, mediana de {count, plural, one {# estação} other {# estações}}, aumentar zoom",
  "weatherMap.legendHeavy": "Forte",
  "weatherMap.legendLight": "Leve",
  "weatherMap.legendLightningHelp": "A cor mostra a idade de cada raio nos últimos {minutes} minutos — os mais recentes em branco, os mais antigos em vermelho escuro.",
  "weatherMap.legendNewest": "Mais recentes",
  "weatherMap.legendOldest": "Mais antigos",
  "weatherMap.legendStationsHelp": "A cor do marcador reflete o valor da métrica selecionada.",
  "weatherMap.lightningDataAttribution": "Dados de raios: Blitzortung.org",
  "weatherMap.lightningStrikes": "Raios",
  "weatherMap.lightningStrikesDescription": "Mostrar raios em tempo real no mapa",
  "weatherMap.mapLayers": "Camadas do mapa",
  "weatherMap.mapLegend": "Legenda do mapa",
  "weatherMap.mapMode": "Modo do mapa",
  "weatherMap.mapNameForecast": "Mapa de previsão, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mapa meteorológico, observações",
  "weatherMap.modeForecast": "Previsão",
  "weatherMap.modeObservations": "Observações",
  "weatherMap.radarCardLabel": "Radar de chuva, {time}",
  "weatherMap.radarDataAttribution": "Dados de radar: NOAA / EUMETNET OPERA / Radar-DPC via LibreWXR",
  "weatherMap.radarLoading": "A carregar o radar de chuva",
  "weatherMap.radarTime": "Hora do radar",
  "weatherMap.radarUnavailable": "Radar indisponível",
  "weatherMap.rainRadar": "Radar de chuva",
  "weatherMap.rainRadarDescription": "Exibir sobreposição de radar de chuva no mapa",
  "weatherMap.resetBearing": "Arraste para rodar o mapa, clique para voltar a orientá-lo a norte",
  "weatherMap.showingForecast": "A mostrar a previsão: {model}, {variable}",
  "weatherMap.stationMarkerName": "{metric} {value}, uma estação",
  "weatherMap.stationMarkersHint": "As teclas de seta passam de uma estação para outra",
  "weatherMap.stationMarkerWindValue": "{speed}, de {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "O NC Rain é uma fonte de dados adicional fornecida através do Tempest Weather System, com tecnologia Nearcast. Os dados NC Rain são uma estimativa da acumulação média de chuva em torno do seu Tempest, ao nível do bairro",
  "weatherMap.weatherMap": "Mapa meteorológico",
  "weatherMap.weatherMapMetaDescription": "SmartMixin oferece mapas meteorológicos e de radar interativos para condições climáticas em todo o mundo.",
  "weatherMap.zoomIn": "Aumentar zoom",
  "weatherMap.zoomOut": "Diminuir zoom",
  "weatherWarnings.activeNow": "Ativos agora",
  "weatherWarnings.agencyMessage": "Mensagem do serviço meteorológico",
  "weatherWarnings.areaCovered": "Zona afetada",
  "weatherWarnings.areaThisLocation": "{area} (este local)",
  "weatherWarnings.areaYourStation": "{area} (sua estação meteorológica)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Aviso oficial, {severity}: {hazard}} one {Aviso oficial, {severity}: {hazard}, e mais #} other {Aviso oficial, {severity}: {hazard}, e mais #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Aviso oficial próximo, {severity}: {hazard}} one {Aviso oficial próximo, {severity}: {hazard}, e mais #} other {Aviso oficial próximo, {severity}: {hazard}, e mais #}}",
  "weatherWarnings.crumb": "Avisos oficiais",
  "weatherWarnings.emptyBody": "O serviço meteorológico nacional não tem nenhum aviso em vigor para este local. Verificamos novamente a cada poucos minutos.",
  "weatherWarnings.emptyTitle": "Nenhum aviso oficial",
  "weatherWarnings.ended": "Terminado",
  "weatherWarnings.endedAt": "Este aviso terminou {time}.",
  "weatherWarnings.errorBody": "Verifique sua conexão. Tentamos novamente a cada poucos minutos.",
  "weatherWarnings.errorTitle": "Não foi possível carregar os avisos oficiais",
  "weatherWarnings.fromTime": "A partir de {time}",
  "weatherWarnings.hazardAirQuality": "Qualidade do ar",
  "weatherWarnings.hazardAvalanche": "Avalanches",
  "weatherWarnings.hazardCoastalEvent": "Fenómenos costeiros",
  "weatherWarnings.hazardFlood": "Inundações",
  "weatherWarnings.hazardFog": "Nevoeiro",
  "weatherWarnings.hazardForestFire": "Incêndios florestais",
  "weatherWarnings.hazardHighTemperature": "Temperaturas elevadas",
  "weatherWarnings.hazardLowTemperature": "Temperaturas baixas",
  "weatherWarnings.hazardOther": "Outro perigo",
  "weatherWarnings.hazardRain": "Chuva",
  "weatherWarnings.hazardSnowIce": "Neve e gelo",
  "weatherWarnings.hazardThunderstorm": "Trovoadas",
  "weatherWarnings.hazardUv": "Radiação UV",
  "weatherWarnings.hazardWind": "Vento",
  "weatherWarnings.hideHazards": "Ocultar perigos",
  "weatherWarnings.issuedBy": "Emitido por {sender}",
  "weatherWarnings.lastUpdate": "Última atualização: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa da zona afetada: {area}.} other {Mapa das # zonas afetadas. {area} está destacada.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mapa da zona afetada.} other {Mapa das # zonas afetadas.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa indisponível. A zona está listada abaixo.} other {Mapa indisponível. As # zonas estão listadas abaixo.}}",
  "weatherWarnings.moreHazards": "+ {count} mais: {hazards}",
  "weatherWarnings.notInLanguage": "Não disponível em {language}. Mostrado tal como o serviço meteorológico o publicou.",
  "weatherWarnings.openOn": "Abrir em {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # outra zona} other {+ # outras zonas}}",
  "weatherWarnings.severityExtreme": "Extremo",
  "weatherWarnings.severityFrom": "{severity} a partir de {time}",
  "weatherWarnings.severityMinor": "Ligeiro",
  "weatherWarnings.severityModerate": "Moderado",
  "weatherWarnings.severityNow": "{severity} agora",
  "weatherWarnings.severitySevere": "Grave",
  "weatherWarnings.severityUntil": "{severity} até {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Mostrar # zona} other {Mostrar as # zonas}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Mostrar # zona no mapa} other {Mostrar as # zonas no mapa}}",
  "weatherWarnings.showHazards": "Mostrar perigos",
  "weatherWarnings.showPeriods": "{count, plural, one {Mostrar # período} other {Mostrar os # períodos}}",
  "weatherWarnings.source": "Fonte: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, depois {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# aviso meteorológico oficial} other {# avisos meteorológicos oficiais}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Avisos meteorológicos oficiais",
  "weatherWarnings.todayAt": "hoje às {time}",
  "weatherWarnings.tomorrow": "Amanhã",
  "weatherWarnings.tomorrowAt": "amanhã às {time}",
  "weatherWarnings.upcoming": "Próximos",
  "weatherWarnings.viewAll": "Todos os avisos oficiais",
  "weatherWarnings.whatToDo": "O que fazer"
}
